export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Base64: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Instant: { input: any; output: any; }
};

export type AcceptEbomPartAllocationSuggestionCommand = {
  id: Scalars['ID']['input'];
  milliQuantity: Scalars['Int']['input'];
};

export type AccountMutationRoot = {
  __typename?: 'AccountMutationRoot';
  adminCreateOrganization: Organization;
  adminCreateUser: User;
  adminDeleteOrganization: Scalars['ID']['output'];
  adminDeleteOrganizationPermissions: Scalars['Boolean']['output'];
  adminSetOrganizationPermissions: Array<PermissionOrganization>;
  adminSetUserPermissions: Array<PermissionUser>;
  adminUpdateOrganization: Organization;
  adminUpdateUser: User;
  agreeToTerms: Scalars['Boolean']['output'];
  deleteOrganizationPermissions: Scalars['Boolean']['output'];
  inviteUserToOrganization: Scalars['Boolean']['output'];
  setOrganizationPermissions: Array<PermissionOrganization>;
  updateOrganization: Organization;
};


export type AccountMutationRootAdminCreateOrganizationArgs = {
  command: CreateOrganization;
};


export type AccountMutationRootAdminCreateUserArgs = {
  command: CreateUser;
};


export type AccountMutationRootAdminDeleteOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type AccountMutationRootAdminDeleteOrganizationPermissionsArgs = {
  command: DeleteOrganizationPermissions;
};


export type AccountMutationRootAdminSetOrganizationPermissionsArgs = {
  command: SetOrganizationPermissions;
};


export type AccountMutationRootAdminSetUserPermissionsArgs = {
  command: SetUserPermissions;
};


export type AccountMutationRootAdminUpdateOrganizationArgs = {
  command: UpdateOrganization;
};


export type AccountMutationRootAdminUpdateUserArgs = {
  command: UpdateUser;
};


export type AccountMutationRootAgreeToTermsArgs = {
  logEntry: Scalars['String']['input'];
};


export type AccountMutationRootDeleteOrganizationPermissionsArgs = {
  command: DeleteOrganizationPermissions;
};


export type AccountMutationRootInviteUserToOrganizationArgs = {
  permissions: Array<InputMaybe<PermissionOrganization>>;
  userCommand: CreateUser;
};


export type AccountMutationRootSetOrganizationPermissionsArgs = {
  command: SetOrganizationPermissions;
};


export type AccountMutationRootUpdateOrganizationArgs = {
  command: UpdateOrganization;
};

export type AccountRoot = {
  __typename?: 'AccountRoot';
  adminOrganizationPermissions: Array<OrganizationUserPermissions>;
  adminOrganizations: Array<Organization>;
  adminSearchUsers: Array<User>;
  adminUser: User;
  adminUserPermissions: Array<PermissionUser>;
  currentOrganization: Organization;
  hasAgreedToTerms: Scalars['Boolean']['output'];
  isEmailTaken: Scalars['Boolean']['output'];
  isOrganizationSlugTaken: Scalars['Boolean']['output'];
  me?: Maybe<CurrentUserAndPermissions>;
  orgPermissionsHierarchy: Array<OrgReachablePermission>;
  organizationBySlug?: Maybe<Organization>;
  organizationPermissions: Array<PermissionOrganization>;
  organizationSearchUsers: Array<User>;
  organizationUser: User;
  organizationUsers: Array<User>;
  organizations: Array<OrganizationUserPermissions>;
};


export type AccountRootAdminOrganizationPermissionsArgs = {
  userId: Scalars['ID']['input'];
};


export type AccountRootAdminSearchUsersArgs = {
  criteria: UserSearchCriteria;
};


export type AccountRootAdminUserArgs = {
  id: Scalars['ID']['input'];
};


export type AccountRootAdminUserPermissionsArgs = {
  userId: Scalars['ID']['input'];
};


export type AccountRootIsEmailTakenArgs = {
  email: Scalars['String']['input'];
  exceptUser?: InputMaybe<Scalars['ID']['input']>;
};


export type AccountRootIsOrganizationSlugTakenArgs = {
  exceptOrganization?: InputMaybe<Scalars['ID']['input']>;
  slug: Scalars['String']['input'];
};


export type AccountRootOrganizationBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type AccountRootOrganizationPermissionsArgs = {
  userId: Scalars['ID']['input'];
};


export type AccountRootOrganizationSearchUsersArgs = {
  criteria: UserSearchCriteria;
};


export type AccountRootOrganizationUserArgs = {
  id: Scalars['ID']['input'];
};


export type AccountRootOrganizationUsersArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type AddTreeGraphNode = {
  entityId: Scalars['ID']['input'];
  node: SetTreeGraphNode;
};

export type AllocateArticleToStepCommand = {
  articleId: Scalars['ID']['input'];
  /** Set for a library reference to scope the allocation to that specific module placement. */
  graphNodeStepId?: InputMaybe<Scalars['ID']['input']>;
  milliQuantity: Scalars['Int']['input'];
  stepId: Scalars['ID']['input'];
};

export type AllocateEbomPartToStepCommand = {
  ebomPartId: Scalars['ID']['input'];
  /** Set for a library reference to scope the allocation to that specific module placement. */
  graphNodeStepId?: InputMaybe<Scalars['ID']['input']>;
  /** Allocates specific occurrences of the EBOM part in the 3D model; milliQuantity must match their count. When omitted, the existing selection is kept only if milliQuantity is unchanged. */
  instanceIndexes?: InputMaybe<Array<Scalars['Int']['input']>>;
  milliQuantity: Scalars['Int']['input'];
  stepId: Scalars['ID']['input'];
};

export type Article = IArticle & {
  __typename?: 'Article';
  articleNumber: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issueLinks: Array<IssueLink>;
  name?: Maybe<Scalars['String']['output']>;
  released: Scalars['Boolean']['output'];
  revision: Scalars['String']['output'];
  type: ArticleType;
  unit: ArticleUnit;
};

export type ArticleAllocation = EbomPartAllocation | ManualArticleAllocation;

export type ArticleIssueLink = IssueLinkI & {
  __typename?: 'ArticleIssueLink';
  article: Article;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: Issue;
};

export type ArticleMutationRoot = {
  __typename?: 'ArticleMutationRoot';
  acceptEbomPartAllocationSuggestion: EbomPartAllocationSuggestion;
  acceptEbomPartAllocationSuggestions: Array<Maybe<Scalars['ID']['output']>>;
  allocateArticleToStep: Scalars['Boolean']['output'];
  allocateEbomPartToStep: Scalars['Boolean']['output'];
  bulkAllocateEbomPartsToStep: Scalars['Boolean']['output'];
  createArticle: Article;
  createEbomPartAllocationSuggestions: Array<EbomPartAllocationSuggestion>;
  deleteArticle: Scalars['ID']['output'];
  deleteEbom: Scalars['ID']['output'];
  loadEbomFromCsv: LoadEbomResult;
  loadEbomFromStepFile: LoadEbomResult;
  promoteEbomPartsToArticles: Array<EbomPart>;
  rejectEbomPartAllocationSuggestion: EbomPartAllocationSuggestion;
  rejectEbomPartAllocationSuggestions: Array<Maybe<Scalars['ID']['output']>>;
  replaceEbomPartAllocations: Scalars['Boolean']['output'];
  snoozeEbomParts: Scalars['Boolean']['output'];
  unsnoozeEbomParts: Scalars['Boolean']['output'];
  updateArticle: Article;
};


export type ArticleMutationRootAcceptEbomPartAllocationSuggestionArgs = {
  command: AcceptEbomPartAllocationSuggestionCommand;
};


export type ArticleMutationRootAcceptEbomPartAllocationSuggestionsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type ArticleMutationRootAllocateArticleToStepArgs = {
  command: AllocateArticleToStepCommand;
};


export type ArticleMutationRootAllocateEbomPartToStepArgs = {
  command: AllocateEbomPartToStepCommand;
};


export type ArticleMutationRootBulkAllocateEbomPartsToStepArgs = {
  command: BulkAllocateEbomPartsToStepCommand;
};


export type ArticleMutationRootCreateArticleArgs = {
  command: CreateArticle;
};


export type ArticleMutationRootCreateEbomPartAllocationSuggestionsArgs = {
  ebomId: Scalars['ID']['input'];
};


export type ArticleMutationRootDeleteArticleArgs = {
  id: Scalars['ID']['input'];
};


export type ArticleMutationRootDeleteEbomArgs = {
  id: Scalars['ID']['input'];
};


export type ArticleMutationRootLoadEbomFromCsvArgs = {
  command: LoadEbomFromCsvCommand;
};


export type ArticleMutationRootLoadEbomFromStepFileArgs = {
  command: LoadEbomFromStepFileCommand;
};


export type ArticleMutationRootPromoteEbomPartsToArticlesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type ArticleMutationRootRejectEbomPartAllocationSuggestionArgs = {
  id: Scalars['ID']['input'];
};


export type ArticleMutationRootRejectEbomPartAllocationSuggestionsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type ArticleMutationRootReplaceEbomPartAllocationsArgs = {
  command: ReplaceEbomPartAllocationsCommand;
};


export type ArticleMutationRootSnoozeEbomPartsArgs = {
  ebomPartIds: Array<Scalars['ID']['input']>;
};


export type ArticleMutationRootUnsnoozeEbomPartsArgs = {
  ebomPartIds: Array<Scalars['ID']['input']>;
};


export type ArticleMutationRootUpdateArticleArgs = {
  command: UpdateArticle;
};

export type ArticlePath = {
  __typename?: 'ArticlePath';
  articleNumbers: Array<Scalars['String']['output']>;
};

export type ArticleRoot = {
  __typename?: 'ArticleRoot';
  article: Article;
  articles: Array<Article>;
  ebom: Ebom;
  ebomPart: EbomPart;
  ebomParts: Array<EbomPart>;
  ebomsForBop: Array<Ebom>;
};


export type ArticleRootArticleArgs = {
  id: Scalars['ID']['input'];
};


export type ArticleRootArticlesArgs = {
  query: ArticleSearchQuery;
};


export type ArticleRootEbomArgs = {
  id: Scalars['ID']['input'];
};


export type ArticleRootEbomPartArgs = {
  id: Scalars['ID']['input'];
};


export type ArticleRootEbomPartsArgs = {
  query: EbomPartSearchQuery;
};


export type ArticleRootEbomsForBopArgs = {
  bopId: Scalars['ID']['input'];
};

export type ArticleSearchQuery = {
  articleNumber?: InputMaybe<Scalars['String']['input']>;
  containsString?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<Scalars['String']['input']>;
};

export enum ArticleType {
  Consumable = 'CONSUMABLE',
  Part = 'PART'
}

export enum ArticleUnit {
  Gram = 'GRAM',
  Kilogram = 'KILOGRAM',
  Liter = 'LITER',
  Meter = 'METER',
  Milliliter = 'MILLILITER',
  Millimeter = 'MILLIMETER',
  Pieces = 'PIECES'
}

export type Bop = {
  __typename?: 'BOP';
  id: Scalars['ID']['output'];
  issueLinks: Array<IssueLink>;
  nodes: Array<ModuleNode>;
  productConfiguration: ProductConfiguration;
  site: Site;
  uploads: Array<BopUpload>;
  version: Scalars['Int']['output'];
  versionStatus: VersionStatus;
};

export type BopIssueLink = IssueLinkI & {
  __typename?: 'BOPIssueLink';
  bop: Bop;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: Issue;
};

export type BopUpload = {
  __typename?: 'BOPUpload';
  bop: Bop;
  glbStatus: GlbStatus;
  glbUpload?: Maybe<Upload>;
  id: Scalars['ID']['output'];
  inUse: Scalars['Boolean']['output'];
  upload: Upload;
};

export type BopUploadUsageLocation = UploadUsageLocationI & {
  __typename?: 'BOPUploadUsageLocation';
  bop?: Maybe<Bop>;
  type: UploadUsageType;
};

export type BulkAllocateEbomPartsToStepCommand = {
  ebomPartIds: Array<Scalars['ID']['input']>;
  graphNodeStepId?: InputMaybe<Scalars['ID']['input']>;
  stepId: Scalars['ID']['input'];
};

export type Check = ConfirmCheck | FileUploadCheck | NumericCheck | StringCheck;

export type CheckConfiguration = {
  __typename?: 'CheckConfiguration';
  allowedMimeTypes?: Maybe<Array<Scalars['String']['output']>>;
  bop?: Maybe<Bop>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  lowerLimit?: Maybe<Scalars['Int']['output']>;
  module?: Maybe<Module>;
  order: Scalars['Int']['output'];
  pinnedId: Scalars['ID']['output'];
  step: Step;
  type: CheckType;
  unit?: Maybe<Scalars['String']['output']>;
  unreleasedChecks: Array<Check>;
  upperLimit?: Maybe<Scalars['Int']['output']>;
};

export type CheckI = {
  configuration: CheckConfiguration;
  createdAt: Scalars['Instant']['output'];
  id: Scalars['ID']['output'];
  poNumber: Scalars['String']['output'];
  released: Scalars['Boolean']['output'];
  reportingUser: User;
  serialNumber: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Instant']['output']>;
};

export type CheckProposal = {
  __typename?: 'CheckProposal';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  lowerLimit?: Maybe<Scalars['Int']['output']>;
  type: CheckType;
  upperLimit?: Maybe<Scalars['Int']['output']>;
};

export type CheckSearchQuery = {
  poNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};

export enum CheckType {
  Confirmation = 'CONFIRMATION',
  FileUpload = 'FILE_UPLOAD',
  Numeric = 'NUMERIC',
  String = 'STRING'
}

export type CheckUploadUsageLocation = UploadUsageLocationI & {
  __typename?: 'CheckUploadUsageLocation';
  bop?: Maybe<Bop>;
  module?: Maybe<Module>;
  step: Step;
  type: UploadUsageType;
};

export type ConfirmCheck = CheckI & {
  __typename?: 'ConfirmCheck';
  configuration: CheckConfiguration;
  confirmed: Scalars['Boolean']['output'];
  createdAt: Scalars['Instant']['output'];
  id: Scalars['ID']['output'];
  poNumber: Scalars['String']['output'];
  released: Scalars['Boolean']['output'];
  reportingUser: User;
  serialNumber: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Instant']['output']>;
};

export type CreateArticle = {
  articleNumber: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<Scalars['String']['input']>;
  type: ArticleType;
  unit: ArticleUnit;
};

export type CreateBopUpload = {
  bopId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  uploadId: Scalars['ID']['input'];
};

export type CreateCheckConfigurationCommand = {
  allowedMimeTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  bopId?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isRequired: Scalars['Boolean']['input'];
  lowerLimit?: InputMaybe<Scalars['Int']['input']>;
  moduleId?: InputMaybe<Scalars['ID']['input']>;
  order: Scalars['Int']['input'];
  stepId: Scalars['ID']['input'];
  type: CheckType;
  unit?: InputMaybe<Scalars['String']['input']>;
  upperLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateIcon = {
  id?: InputMaybe<Scalars['ID']['input']>;
  imageUploadId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type CreateImageStepUpload = {
  caption?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  stepId: Scalars['ID']['input'];
  uploadId: Scalars['ID']['input'];
};

export type CreateIssue = {
  assignedToUserIds: Array<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  uploadIds: Array<Scalars['ID']['input']>;
};

export type CreateIssueComment = {
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  issueId: Scalars['ID']['input'];
  uploadIds: Array<Scalars['ID']['input']>;
};

export type CreateIssueLabel = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateModule = {
  abbreviation: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
};

export type CreateMultipartUpload = {
  contentType: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type CreateOrganization = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type CreateProduct = {
  abbreviation: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  imageUploadId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type CreateProductConfiguration = {
  abbreviation: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  forProductId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  imageUploadId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type CreateProductionBatchCommand = {
  assignedUserId?: InputMaybe<Scalars['ID']['input']>;
  bopId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  moduleId: Scalars['ID']['input'];
  poNumber: Scalars['String']['input'];
  serialNumbers: Array<Scalars['ID']['input']>;
};

export type CreateSite = {
  abbreviation: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type CreateSnapshotStepUpload = {
  /** The step upload (attachment) ID of the source video. Either this or uploadId must be provided. */
  attachmentId?: InputMaybe<Scalars['ID']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  stepId: Scalars['ID']['input'];
  timestampInMillis: Scalars['Int']['input'];
  /** The raw upload ID of the source video. Either this or attachmentId must be provided. */
  uploadId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateSnapshotUpload = {
  timestampInMillis: Scalars['Int']['input'];
  /** The raw upload ID of the source video. */
  uploadId: Scalars['ID']['input'];
};

export type CreateStep = {
  durationInSeconds: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  instructionText?: InputMaybe<Scalars['String']['input']>;
  library?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  productId?: InputMaybe<Scalars['ID']['input']>;
  stepTypeId: Scalars['ID']['input'];
  toolIds: Array<Scalars['ID']['input']>;
  warningText?: InputMaybe<Scalars['String']['input']>;
};

export type CreateStepInput = {
  /** Set for a library reference to scope the input to that specific module placement. */
  graphNodeStepId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  milliQuantity: Scalars['Int']['input'];
  moduleId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
  stepOutputId: Scalars['ID']['input'];
};

export type CreateStepOutput = {
  articleId: Scalars['ID']['input'];
  /** Set for a library reference to scope the output to that specific module placement. */
  graphNodeStepId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  milliQuantity: Scalars['Int']['input'];
  moduleId?: InputMaybe<Scalars['ID']['input']>;
  stepId: Scalars['ID']['input'];
};

export type CreateStepProposalsFromDocx = {
  additionalPrompt?: InputMaybe<Scalars['String']['input']>;
  fromUploadId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  language: Language;
  outLanguage?: InputMaybe<Language>;
};

export type CreateStepProposalsFromMedia = {
  additionalPrompt?: InputMaybe<Scalars['String']['input']>;
  averageStepSizeInSeconds?: InputMaybe<Scalars['Int']['input']>;
  fromUploadId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  inLanguage: Language;
  outLanguage?: InputMaybe<Language>;
};

export type CreateStepProposalsFromPdf = {
  additionalPrompt?: InputMaybe<Scalars['String']['input']>;
  firstPage: Scalars['Int']['input'];
  fromUploadId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  language: Language;
  lastPage: Scalars['Int']['input'];
  outLanguage?: InputMaybe<Language>;
};

export type CreateStepType = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type CreateTool = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  imageUploadIds: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};

export type CreateUser = {
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  lastname: Scalars['String']['input'];
  needsPassword: Scalars['Boolean']['input'];
};

export type CreateVideoStepUpload = {
  caption?: InputMaybe<Scalars['String']['input']>;
  fragmentEndInMillis?: InputMaybe<Scalars['Int']['input']>;
  fragmentLoop?: InputMaybe<Scalars['Boolean']['input']>;
  fragmentStartInMillis?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  stepId: Scalars['ID']['input'];
  uploadId: Scalars['ID']['input'];
};

export type CsvConfig = {
  articleNumberColumn: Scalars['String']['input'];
  ebomName: Scalars['String']['input'];
  encoding: CsvEncoding;
  nameColumn?: InputMaybe<Scalars['String']['input']>;
  parentArticleNumberColumn?: InputMaybe<Scalars['String']['input']>;
  positionColumn?: InputMaybe<Scalars['String']['input']>;
  quantityColumn: Scalars['String']['input'];
  revisionColumn: Scalars['String']['input'];
  unitColumn?: InputMaybe<Scalars['String']['input']>;
};

export enum CsvEncoding {
  Iso_8859_1 = 'ISO_8859_1',
  UsAscii = 'US_ASCII',
  Utf_8 = 'UTF_8'
}

export type CsvExtension = {
  __typename?: 'CsvExtension';
  columnNames: Array<Scalars['String']['output']>;
};

export type CurrentUserAndPermissions = {
  __typename?: 'CurrentUserAndPermissions';
  orgPermissions: Array<PermissionOrganization>;
  organization?: Maybe<Organization>;
  user: User;
  userPermissions: Array<PermissionUser>;
};

export type DagNode = {
  id: Scalars['ID']['output'];
  parentIds: Array<Scalars['ID']['output']>;
};

export type DeleteCheckCommand = {
  checkConfigurationId: Scalars['ID']['input'];
  poNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};

export type DeleteOrganizationPermissions = {
  orgId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type DraftBopByDuplicating = {
  bopId: Scalars['ID']['input'];
  productConfigId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};

export type DuplicateModule = {
  fromBOPId: Scalars['ID']['input'];
  fromModuleId: Scalars['ID']['input'];
  toBOPId: Scalars['ID']['input'];
};

export type DuplicateStep = {
  fromBOPId: Scalars['ID']['input'];
  fromModuleId: Scalars['ID']['input'];
  fromStepId: Scalars['ID']['input'];
  toBOPId: Scalars['ID']['input'];
  toModuleId: Scalars['ID']['input'];
};

export type Ebom = {
  __typename?: 'Ebom';
  bopUpload?: Maybe<BopUpload>;
  ebomParts: Array<EbomPart>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  sourceType: EbomSourceType;
};

/**
 * A part in the EBOM in a specific assembly (which could be the root assembly).
 * The EBOM can consist of multiple EbomParts, referencing the same Part but in a diferent assembly in the EBOM.
 */
export type EbomPart = IArticle & {
  __typename?: 'EbomPart';
  article?: Maybe<Article>;
  articleNumber: Scalars['String']['output'];
  articlePath: ArticlePath;
  ebomId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** How many times the Part was present in the assembly in 1/1000 unit */
  milliQuantity: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['ID']['output']>;
  /** Position number from CSV import when position-based hierarchy was used (e.g., '10.10.20') */
  position?: Maybe<Scalars['String']['output']>;
  revision: Scalars['String']['output'];
  snoozeStatus: EbomPartSnoozeStatus;
  stepAllocationSuggestions: Array<EbomPartAllocationSuggestion>;
  stepAllocations: Array<EbomPartAllocation>;
  unit: ArticleUnit;
};

export type EbomPartAllocation = IArticleAllocation & {
  __typename?: 'EbomPartAllocation';
  article: Article;
  ebomPart: EbomPart;
  id: Scalars['ID']['output'];
  /** Indexes of the EBOM part's occurrences in the 3D model that are allocated, ordered by position. Null when not tied to specific occurrences. */
  instanceIndexes?: Maybe<Array<Scalars['Int']['output']>>;
  milliQuantity: Scalars['Int']['output'];
  step: Step;
};

export type EbomPartAllocationSuggestion = {
  __typename?: 'EbomPartAllocationSuggestion';
  decision: EbomPartAllocationSuggestionDecision;
  ebomPart: EbomPart;
  id: Scalars['ID']['output'];
  milliQuantity: Scalars['Int']['output'];
  source: EbomPartAllocationSuggestionSource;
  step: Step;
};

export enum EbomPartAllocationSuggestionDecision {
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED',
  Undecided = 'UNDECIDED'
}

export enum EbomPartAllocationSuggestionSource {
  PreviousEbomAllocation = 'PREVIOUS_EBOM_ALLOCATION',
  HistoricAllocation = 'HISTORIC_ALLOCATION'
}

export type EbomPartSearchQuery = {
  contextGraphNodeStepId?: InputMaybe<Scalars['ID']['input']>;
  contextStepId?: InputMaybe<Scalars['ID']['input']>;
  ebomId: Scalars['ID']['input'];
  searchString: Scalars['String']['input'];
};

export enum EbomPartSnoozeStatus {
  None = 'NONE',
  PathArticle = 'PATH_ARTICLE',
  PathArticleRevision = 'PATH_ARTICLE_REVISION',
  PathArticleRevisionQuantity = 'PATH_ARTICLE_REVISION_QUANTITY'
}

export enum EbomSourceType {
  Csv = 'CSV',
  Step = 'STEP'
}

export type FileUploadCheck = CheckI & {
  __typename?: 'FileUploadCheck';
  configuration: CheckConfiguration;
  createdAt: Scalars['Instant']['output'];
  id: Scalars['ID']['output'];
  poNumber: Scalars['String']['output'];
  released: Scalars['Boolean']['output'];
  reportingUser: User;
  serialNumber: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Instant']['output']>;
  upload: Upload;
};

export type GenericExtension = {
  __typename?: 'GenericExtension';
  uploadId: Scalars['ID']['output'];
};

export enum GlbStatus {
  Converting = 'CONVERTING',
  Done = 'DONE',
  Failed = 'FAILED',
  None = 'NONE',
  Queued = 'QUEUED'
}

export enum GraphEntityType {
  BillOfProcess = 'BILL_OF_PROCESS',
  Module = 'MODULE',
  Step = 'STEP'
}

export type IArticle = {
  articleNumber: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  revision: Scalars['String']['output'];
  unit: ArticleUnit;
};

export type IArticleAllocation = {
  article: Article;
  id: Scalars['ID']['output'];
  milliQuantity: Scalars['Int']['output'];
  step: Step;
};

export type IStepUpload = {
  id: Scalars['ID']['output'];
  upload: Upload;
};

export type Icon = {
  __typename?: 'Icon';
  id: Scalars['ID']['output'];
  /** Null only for a deleted icon whose image was removed */
  imageUpload?: Maybe<Upload>;
  name: Scalars['String']['output'];
};

export type IconUploadUsageLocation = UploadUsageLocationI & {
  __typename?: 'IconUploadUsageLocation';
  icon?: Maybe<Icon>;
  type: UploadUsageType;
};

export type ImageExtension = {
  __typename?: 'ImageExtension';
  url: Scalars['String']['output'];
};


export type ImageExtensionUrlArgs = {
  options: ImageOptions;
};

export type ImageOptions = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageStepUpload = IStepUpload & {
  __typename?: 'ImageStepUpload';
  caption?: Maybe<Scalars['String']['output']>;
  /** Opaque, client-authored editor state applied on top of originalUpload. Null if never edited. */
  editLayer?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The pristine, never-edited source image. Null if this attachment has never been edited. */
  originalUpload?: Maybe<Upload>;
  upload: Upload;
};

export type InviteUserToOrganization = {
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  lastname: Scalars['String']['input'];
  needsPassword: Scalars['Boolean']['input'];
  permissions: Array<PermissionOrganization>;
};

export type Issue = {
  __typename?: 'Issue';
  assignedToUserIds: Array<Scalars['ID']['output']>;
  assignedToUsers: Array<User>;
  comments: Array<IssueComment>;
  createdAt: Scalars['Instant']['output'];
  createdByUser: User;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  labels: Array<IssueLabel>;
  links: Array<IssueLink>;
  name: Scalars['String']['output'];
  resolvedAt?: Maybe<Scalars['Instant']['output']>;
  updatedAt: Scalars['Instant']['output'];
  uploadIds: Array<Scalars['ID']['output']>;
  uploads: Array<Upload>;
};

export type IssueComment = {
  __typename?: 'IssueComment';
  createdAt: Scalars['Instant']['output'];
  createdByUser: User;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  resolvedAt?: Maybe<Scalars['Instant']['output']>;
  updatedAt: Scalars['Instant']['output'];
  uploadIds: Array<Scalars['ID']['output']>;
  uploads: Array<Upload>;
};

export type IssueCommentUploadUsageLocation = UploadUsageLocationI & {
  __typename?: 'IssueCommentUploadUsageLocation';
  comment: IssueComment;
  issue: Issue;
  type: UploadUsageType;
};

export type IssueLabel = {
  __typename?: 'IssueLabel';
  color: Scalars['String']['output'];
  createdAt: Scalars['Instant']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  orgId: Scalars['ID']['output'];
  updatedAt: Scalars['Instant']['output'];
};

export type IssueLink = ArticleIssueLink | BopIssueLink | ModuleIssueLink | SerialNumberIssueLink | StepIssueLink;

export type IssueLinkI = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: Issue;
};

export type IssueMutationRoot = {
  __typename?: 'IssueMutationRoot';
  createIssue: Issue;
  createIssueComment: IssueComment;
  createIssueLabel: IssueLabel;
  deleteIssue: Scalars['ID']['output'];
  deleteIssueComment: Scalars['ID']['output'];
  deleteIssueLabel: Scalars['ID']['output'];
  deleteIssueLink: Scalars['ID']['output'];
  linkIssueToArticle: ArticleIssueLink;
  linkIssueToBOP: BopIssueLink;
  linkIssueToModule: ModuleIssueLink;
  linkIssueToSerialNumber: SerialNumberIssueLink;
  linkIssueToSerialNumbers: Array<SerialNumberIssueLink>;
  linkIssueToStep: StepIssueLink;
  setIssueCommentResolved: IssueComment;
  setIssueLabels: Array<IssueLabel>;
  updateIssue: Issue;
  updateIssueComment: IssueComment;
  updateIssueLabel: IssueLabel;
  updateIssueLink: IssueLink;
};


export type IssueMutationRootCreateIssueArgs = {
  command: CreateIssue;
};


export type IssueMutationRootCreateIssueCommentArgs = {
  command: CreateIssueComment;
};


export type IssueMutationRootCreateIssueLabelArgs = {
  command: CreateIssueLabel;
};


export type IssueMutationRootDeleteIssueArgs = {
  id: Scalars['ID']['input'];
};


export type IssueMutationRootDeleteIssueCommentArgs = {
  id: Scalars['ID']['input'];
};


export type IssueMutationRootDeleteIssueLabelArgs = {
  id: Scalars['ID']['input'];
};


export type IssueMutationRootDeleteIssueLinkArgs = {
  id: Scalars['ID']['input'];
};


export type IssueMutationRootLinkIssueToArticleArgs = {
  command: LinkIssueToArticle;
};


export type IssueMutationRootLinkIssueToBopArgs = {
  command: LinkIssueToBop;
};


export type IssueMutationRootLinkIssueToModuleArgs = {
  command: LinkIssueToModule;
};


export type IssueMutationRootLinkIssueToSerialNumberArgs = {
  command: LinkIssueToSerialNumber;
};


export type IssueMutationRootLinkIssueToSerialNumbersArgs = {
  command: LinkIssueToSerialNumbers;
};


export type IssueMutationRootLinkIssueToStepArgs = {
  command: LinkIssueToStep;
};


export type IssueMutationRootSetIssueCommentResolvedArgs = {
  command: SetIssueResolved;
};


export type IssueMutationRootSetIssueLabelsArgs = {
  command: SetIssueLabels;
};


export type IssueMutationRootUpdateIssueArgs = {
  command: UpdateIssue;
};


export type IssueMutationRootUpdateIssueCommentArgs = {
  command: UpdateIssueComment;
};


export type IssueMutationRootUpdateIssueLabelArgs = {
  command: UpdateIssueLabel;
};


export type IssueMutationRootUpdateIssueLinkArgs = {
  command: UpdateIssueLink;
};

export type IssueRoot = {
  __typename?: 'IssueRoot';
  issue: Issue;
  issueComment: IssueComment;
  issueLink: IssueLink;
  issues: Array<Issue>;
  issuesPerDay: Array<IssuesPerDay>;
  orgIssueLabels: Array<IssueLabel>;
};


export type IssueRootIssueArgs = {
  id: Scalars['ID']['input'];
};


export type IssueRootIssueCommentArgs = {
  id: Scalars['ID']['input'];
};


export type IssueRootIssueLinkArgs = {
  id: Scalars['ID']['input'];
};


export type IssueRootIssuesArgs = {
  query: IssueSearchQuery;
};


export type IssueRootIssuesPerDayArgs = {
  from: Scalars['DateTime']['input'];
  till: Scalars['DateTime']['input'];
};

export type IssueSearchQuery = {
  assignedToUserId?: InputMaybe<Scalars['ID']['input']>;
  bopIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isResolved?: InputMaybe<Scalars['Boolean']['input']>;
  labelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  poNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  serialNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  sortBy?: InputMaybe<IssueSortBy>;
  sortDirection?: InputMaybe<SortDirection>;
};

export enum IssueSortBy {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type IssueUploadUsageLocation = UploadUsageLocationI & {
  __typename?: 'IssueUploadUsageLocation';
  issue: Issue;
  type: UploadUsageType;
};

export type IssuesPerDay = {
  __typename?: 'IssuesPerDay';
  created: Scalars['Int']['output'];
  day: Scalars['Instant']['output'];
  open: Scalars['Int']['output'];
  resolved: Scalars['Int']['output'];
};

export enum Language {
  En = 'EN',
  Nl = 'NL'
}

export type LinkIssueToArticle = {
  articleId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  issueId: Scalars['ID']['input'];
};

export type LinkIssueToBop = {
  bopId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  issueId: Scalars['ID']['input'];
};

export type LinkIssueToModule = {
  bopId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  issueId: Scalars['ID']['input'];
  moduleId: Scalars['ID']['input'];
};

export type LinkIssueToSerialNumber = {
  bopId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  issueId: Scalars['ID']['input'];
  moduleId: Scalars['ID']['input'];
  poNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
  stepId: Scalars['ID']['input'];
};

export type LinkIssueToSerialNumbers = {
  bopId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  issueId: Scalars['ID']['input'];
  moduleId: Scalars['ID']['input'];
  poNumber: Scalars['String']['input'];
  serialNumbers: Array<Scalars['String']['input']>;
  stepId: Scalars['ID']['input'];
};

export type LinkIssueToStep = {
  bopId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  issueId: Scalars['ID']['input'];
  moduleId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
};

export type LoadEbomFromCsvCommand = {
  bopId: Scalars['ID']['input'];
  config: CsvConfig;
  uploadId: Scalars['ID']['input'];
};

export type LoadEbomFromStepFileCommand = {
  bopId: Scalars['ID']['input'];
  ebomName: Scalars['String']['input'];
  uploadId: Scalars['ID']['input'];
};

export type LoadEbomResult = {
  __typename?: 'LoadEbomResult';
  ebom?: Maybe<Ebom>;
  error?: Maybe<Scalars['String']['output']>;
};

export type ManualArticleAllocation = IArticleAllocation & {
  __typename?: 'ManualArticleAllocation';
  article: Article;
  id: Scalars['ID']['output'];
  milliQuantity: Scalars['Int']['output'];
  step: Step;
};

export type ModelExtension = {
  __typename?: 'ModelExtension';
  uploadId: Scalars['ID']['output'];
};

export type Module = {
  __typename?: 'Module';
  abbreviation: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inputs: Array<StepInput>;
  issueLinks: Array<IssueLink>;
  name: Scalars['String']['output'];
  nodes: Array<StepNode>;
  outputs: Array<StepOutput>;
  /** Steps removed since the operator last viewed this module's BOP, as they were in the last-seen version */
  removedSteps: Array<RemovedStep>;
};


export type ModuleNodesArgs = {
  bopId?: InputMaybe<Scalars['ID']['input']>;
};


export type ModuleRemovedStepsArgs = {
  bopId: Scalars['ID']['input'];
};

export type ModuleIssueLink = IssueLinkI & {
  __typename?: 'ModuleIssueLink';
  bop: Bop;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: Issue;
  module: Module;
};

export type ModuleNode = DagNode & {
  __typename?: 'ModuleNode';
  id: Scalars['ID']['output'];
  module: Module;
  parentIds: Array<Scalars['ID']['output']>;
};

export type Move = {
  ids: Array<Scalars['ID']['input']>;
  otherId: Scalars['ID']['input'];
  placement: Placement;
};

export type Mutation = {
  __typename?: 'Mutation';
  account: AccountMutationRoot;
  article: ArticleMutationRoot;
  issue: IssueMutationRoot;
  product: ProductMutationRoot;
  shopFloor: ShopFloorMutationRoot;
  site: SiteMutationRoot;
  upload: UploadMutationRoot;
};

export type NumericCheck = CheckI & {
  __typename?: 'NumericCheck';
  configuration: CheckConfiguration;
  createdAt: Scalars['Instant']['output'];
  id: Scalars['ID']['output'];
  milliQuantity: Scalars['Int']['output'];
  poNumber: Scalars['String']['output'];
  released: Scalars['Boolean']['output'];
  reportingUser: User;
  serialNumber: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Instant']['output']>;
};

export type OrgReachablePermission = {
  __typename?: 'OrgReachablePermission';
  permission: PermissionOrganization;
  reachable: Array<PermissionOrganization>;
};

export type Organization = {
  __typename?: 'Organization';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type OrganizationUserPermissions = {
  __typename?: 'OrganizationUserPermissions';
  organization: Organization;
  permissions: Array<PermissionOrganization>;
};

export type PdfExtension = {
  __typename?: 'PdfExtension';
  analysis: PdfExtensionAnalysis;
};

export type PdfExtensionAnalysis = {
  __typename?: 'PdfExtensionAnalysis';
  errors: Array<Scalars['String']['output']>;
  numberOfImages: Scalars['Int']['output'];
  numberOfPages: Scalars['Int']['output'];
};

export enum PermissionOrganization {
  OrgAdmin = 'ORG_ADMIN',
  OrgArticleDelete = 'ORG_ARTICLE_DELETE',
  OrgArticleRead = 'ORG_ARTICLE_READ',
  OrgArticleWrite = 'ORG_ARTICLE_WRITE',
  OrgEbomDelete = 'ORG_EBOM_DELETE',
  OrgEbomRead = 'ORG_EBOM_READ',
  OrgEbomWrite = 'ORG_EBOM_WRITE',
  OrgIssueComment = 'ORG_ISSUE_COMMENT',
  OrgIssueDelete = 'ORG_ISSUE_DELETE',
  OrgIssueRead = 'ORG_ISSUE_READ',
  OrgIssueWrite = 'ORG_ISSUE_WRITE',
  OrgMbomRead = 'ORG_MBOM_READ',
  OrgMember = 'ORG_MEMBER',
  OrgProductionBatchDelete = 'ORG_PRODUCTION_BATCH_DELETE',
  OrgProductionBatchRead = 'ORG_PRODUCTION_BATCH_READ',
  OrgProductionBatchWrite = 'ORG_PRODUCTION_BATCH_WRITE',
  OrgProductDelete = 'ORG_PRODUCT_DELETE',
  OrgProductRead = 'ORG_PRODUCT_READ',
  OrgProductWrite = 'ORG_PRODUCT_WRITE',
  OrgUploadDelete = 'ORG_UPLOAD_DELETE',
  OrgUploadIndex = 'ORG_UPLOAD_INDEX',
  OrgUploadOwn = 'ORG_UPLOAD_OWN',
  OrgUploadWrite = 'ORG_UPLOAD_WRITE'
}

export enum PermissionUser {
  UserGlobalAdmin = 'USER_GLOBAL_ADMIN'
}

export enum Placement {
  Above = 'ABOVE',
  Below = 'BELOW'
}

export type Product = {
  __typename?: 'Product';
  abbreviation: Scalars['String']['output'];
  archived: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUpload?: Maybe<Upload>;
  imageUploadId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  productConfigurations: Array<ProductConfiguration>;
};

export type ProductConfiguration = {
  __typename?: 'ProductConfiguration';
  abbreviation: Scalars['String']['output'];
  /** True when the configuration itself or its product is archived */
  archived: Scalars['Boolean']['output'];
  bops: Array<Bop>;
  bopsAtSite: Array<Bop>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUpload?: Maybe<Upload>;
  imageUploadId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  product: Product;
};


export type ProductConfigurationBopsAtSiteArgs = {
  siteId: Scalars['ID']['input'];
};

export type ProductConfigurationUploadUsageLocation = UploadUsageLocationI & {
  __typename?: 'ProductConfigurationUploadUsageLocation';
  product?: Maybe<Product>;
  productConfiguration: ProductConfiguration;
  type: UploadUsageType;
};

export type ProductMutationRoot = {
  __typename?: 'ProductMutationRoot';
  /** Top entity id refers to module id, node entity types are steps and entity ids refer to step ids */
  addNodeToModuleGraph: Scalars['Boolean']['output'];
  archiveProduct: Product;
  archiveProductConfiguration: ProductConfiguration;
  clearImageStepUploadEdit: ImageStepUpload;
  createBOPUpload: BopUpload;
  createCheckConfiguration: CheckConfiguration;
  createIcon: Icon;
  createImageStepUpload: ImageStepUpload;
  createModule: Module;
  createProduct: Product;
  createProductConfiguration: ProductConfiguration;
  createSnapshotStepUpload: ImageStepUpload;
  createStep: Step;
  createStepInput: StepInput;
  createStepOutput: StepOutput;
  createStepProposalsFromDOCX: StepProposalResult;
  createStepProposalsFromMedia: StepProposalResult;
  createStepProposalsFromPDF: StepProposalResult;
  createStepType: StepType;
  createVideoStepUpload: VideoStepUpload;
  createVideoStepUploads: Array<VideoStepUpload>;
  deleteBOPUpload: Scalars['ID']['output'];
  deleteCheckConfiguration: Scalars['ID']['output'];
  deleteIcon: Scalars['ID']['output'];
  /** Deletes latest BOP version, only if it is not released */
  deleteLatestUnreleasedBOPVersion?: Maybe<Scalars['ID']['output']>;
  deleteModule?: Maybe<Scalars['ID']['output']>;
  deleteProduct: Scalars['ID']['output'];
  deleteProductConfiguration: Scalars['ID']['output'];
  deleteStep?: Maybe<Scalars['ID']['output']>;
  deleteStepInput: Scalars['ID']['output'];
  deleteStepOutput: Scalars['ID']['output'];
  deleteStepType: Scalars['ID']['output'];
  deleteStepUpload: Scalars['ID']['output'];
  /** Creates a new BOP draft, only if a new lineage is started or previous version was released */
  draftBOP: Bop;
  /** Creates a new BOP draft by duplicating another BOP, only if it starts a new lineage */
  draftBOPByDuplicating: Bop;
  duplicateModule: Module;
  duplicateStep: Step;
  moveCheckConfiguration: Scalars['Boolean']['output'];
  moveStepUpload: Scalars['Boolean']['output'];
  /** Turns a step into a module of its own: the step moves out of its module, substeps and all. */
  promoteStepToModule: Module;
  releaseLatestBOPVersion: Bop;
  /** Remove a single step node from a module graph by its graph node id */
  removeNodeFromModuleGraph: Scalars['Boolean']['output'];
  saveImageStepUploadEdit: ImageStepUpload;
  saveStepArticleTransforms: Array<StepArticleTransform>;
  saveStepViewport: StepViewport;
  /** Top entity id refers to BOP id, node entity types are modules and entity ids refer to module ids */
  setBillOfProcessGraph: Scalars['Boolean']['output'];
  /** Top entity id refers to module id, node entity types are steps and entity ids refer to step ids */
  setModuleGraph: Scalars['Boolean']['output'];
  /** Replaces the tools of a library-reference placement (scoped to that module usage). */
  setPlacementTools: Scalars['Boolean']['output'];
  /** Sets which previously-allocated articles the 3D viewer shows for a step. Saved per step. */
  setStepArticleVisibility: Step;
  setStepDurations: Scalars['Boolean']['output'];
  /** Replaces the icons of a step, keeping the given order */
  setStepIcons: Step;
  /** Selects which BOPUpload's 3D model is shown on a step, overriding the automatic choice. Pass null to go back to the automatic choice. */
  setStepPreferred3dModel: Step;
  unarchiveProduct: Product;
  unarchiveProductConfiguration: ProductConfiguration;
  unlinkLibraryStep: Step;
  updateCheckConfiguration: CheckConfiguration;
  updateIcon: Icon;
  updateImageStepUpload: ImageStepUpload;
  updateModule: Module;
  updateProduct: Product;
  updateProductConfiguration: ProductConfiguration;
  updateStep: Step;
  updateStepInput: StepInput;
  updateStepOutput: StepOutput;
  updateStepType: StepType;
  updateVideoStepUpload: VideoStepUpload;
};


export type ProductMutationRootAddNodeToModuleGraphArgs = {
  command: AddTreeGraphNode;
};


export type ProductMutationRootArchiveProductArgs = {
  id: Scalars['ID']['input'];
};


export type ProductMutationRootArchiveProductConfigurationArgs = {
  id: Scalars['ID']['input'];
};


export type ProductMutationRootClearImageStepUploadEditArgs = {
  id: Scalars['ID']['input'];
};


export type ProductMutationRootCreateBopUploadArgs = {
  command: CreateBopUpload;
};


export type ProductMutationRootCreateCheckConfigurationArgs = {
  command: CreateCheckConfigurationCommand;
};


export type ProductMutationRootCreateIconArgs = {
  command: CreateIcon;
};


export type ProductMutationRootCreateImageStepUploadArgs = {
  command: CreateImageStepUpload;
};


export type ProductMutationRootCreateModuleArgs = {
  command: CreateModule;
};


export type ProductMutationRootCreateProductArgs = {
  command: CreateProduct;
};


export type ProductMutationRootCreateProductConfigurationArgs = {
  command: CreateProductConfiguration;
};


export type ProductMutationRootCreateSnapshotStepUploadArgs = {
  command: CreateSnapshotStepUpload;
};


export type ProductMutationRootCreateStepArgs = {
  command: CreateStep;
};


export type ProductMutationRootCreateStepInputArgs = {
  command: CreateStepInput;
};


export type ProductMutationRootCreateStepOutputArgs = {
  command: CreateStepOutput;
};


export type ProductMutationRootCreateStepProposalsFromDocxArgs = {
  command: CreateStepProposalsFromDocx;
};


export type ProductMutationRootCreateStepProposalsFromMediaArgs = {
  command: CreateStepProposalsFromMedia;
};


export type ProductMutationRootCreateStepProposalsFromPdfArgs = {
  command: CreateStepProposalsFromPdf;
};


export type ProductMutationRootCreateStepTypeArgs = {
  command: CreateStepType;
};


export type ProductMutationRootCreateVideoStepUploadArgs = {
  command: CreateVideoStepUpload;
};


export type ProductMutationRootCreateVideoStepUploadsArgs = {
  commands: Array<CreateVideoStepUpload>;
};


export type ProductMutationRootDeleteBopUploadArgs = {
  id: Scalars['ID']['input'];
};


export type ProductMutationRootDeleteCheckConfigurationArgs = {
  id: Scalars['ID']['input'];
};


export type ProductMutationRootDeleteIconArgs = {
  id: Scalars['ID']['input'];
};


export type ProductMutationRootDeleteLatestUnreleasedBopVersionArgs = {
  atSiteId: Scalars['ID']['input'];
  forProductConfigId: Scalars['ID']['input'];
};


export type ProductMutationRootDeleteModuleArgs = {
  id: Scalars['ID']['input'];
};


export type ProductMutationRootDeleteProductArgs = {
  id: Scalars['ID']['input'];
};


export type ProductMutationRootDeleteProductConfigurationArgs = {
  id: Scalars['ID']['input'];
};


export type ProductMutationRootDeleteStepArgs = {
  id: Scalars['ID']['input'];
};


export type ProductMutationRootDeleteStepInputArgs = {
  id: Scalars['ID']['input'];
};


export type ProductMutationRootDeleteStepOutputArgs = {
  id: Scalars['ID']['input'];
};


export type ProductMutationRootDeleteStepTypeArgs = {
  id: Scalars['ID']['input'];
};


export type ProductMutationRootDeleteStepUploadArgs = {
  id: Scalars['ID']['input'];
};


export type ProductMutationRootDraftBopArgs = {
  atSiteId: Scalars['ID']['input'];
  forProductConfigId: Scalars['ID']['input'];
};


export type ProductMutationRootDraftBopByDuplicatingArgs = {
  command: DraftBopByDuplicating;
};


export type ProductMutationRootDuplicateModuleArgs = {
  command: DuplicateModule;
};


export type ProductMutationRootDuplicateStepArgs = {
  command: DuplicateStep;
};


export type ProductMutationRootMoveCheckConfigurationArgs = {
  command: Move;
  inStepId: Scalars['ID']['input'];
};


export type ProductMutationRootMoveStepUploadArgs = {
  command: Move;
  inStepId: Scalars['ID']['input'];
};


export type ProductMutationRootPromoteStepToModuleArgs = {
  command: PromoteStepToModule;
};


export type ProductMutationRootReleaseLatestBopVersionArgs = {
  atSiteId: Scalars['ID']['input'];
  forProductConfigId: Scalars['ID']['input'];
};


export type ProductMutationRootRemoveNodeFromModuleGraphArgs = {
  graphNodeStepId: Scalars['ID']['input'];
};


export type ProductMutationRootSaveImageStepUploadEditArgs = {
  command: SaveImageStepUploadEdit;
};


export type ProductMutationRootSaveStepArticleTransformsArgs = {
  command: SaveStepArticleTransforms;
};


export type ProductMutationRootSaveStepViewportArgs = {
  command: SaveStepViewport;
};


export type ProductMutationRootSetBillOfProcessGraphArgs = {
  command: SetDagGraph;
};


export type ProductMutationRootSetModuleGraphArgs = {
  command: SetTreeGraph;
};


export type ProductMutationRootSetPlacementToolsArgs = {
  command: SetPlacementTools;
};


export type ProductMutationRootSetStepArticleVisibilityArgs = {
  command: SetStepArticleVisibility;
};


export type ProductMutationRootSetStepDurationsArgs = {
  command: SetStepDurations;
};


export type ProductMutationRootSetStepIconsArgs = {
  command: SetStepIcons;
};


export type ProductMutationRootSetStepPreferred3dModelArgs = {
  command: SetStepPreferred3dModel;
};


export type ProductMutationRootUnarchiveProductArgs = {
  id: Scalars['ID']['input'];
};


export type ProductMutationRootUnarchiveProductConfigurationArgs = {
  id: Scalars['ID']['input'];
};


export type ProductMutationRootUnlinkLibraryStepArgs = {
  command: UnlinkLibraryStep;
};


export type ProductMutationRootUpdateCheckConfigurationArgs = {
  command: UpdateCheckConfigurationCommand;
};


export type ProductMutationRootUpdateIconArgs = {
  command: UpdateIcon;
};


export type ProductMutationRootUpdateImageStepUploadArgs = {
  command: UpdateImageStepUpload;
};


export type ProductMutationRootUpdateModuleArgs = {
  command: UpdateModule;
};


export type ProductMutationRootUpdateProductArgs = {
  command: UpdateProduct;
};


export type ProductMutationRootUpdateProductConfigurationArgs = {
  command: UpdateProductConfiguration;
};


export type ProductMutationRootUpdateStepArgs = {
  command: UpdateStep;
};


export type ProductMutationRootUpdateStepInputArgs = {
  command: UpdateStepInput;
};


export type ProductMutationRootUpdateStepOutputArgs = {
  command: UpdateStepOutput;
};


export type ProductMutationRootUpdateStepTypeArgs = {
  command: UpdateStepType;
};


export type ProductMutationRootUpdateVideoStepUploadArgs = {
  command: UpdateVideoStepUpload;
};

export type ProductRoot = {
  __typename?: 'ProductRoot';
  bop: Bop;
  bopUpload: BopUpload;
  checkConfigurations: Array<CheckConfiguration>;
  createStepProposalsFromMediaSupportedMimeTypes: Array<Scalars['String']['output']>;
  /** The company icon library, without deleted icons */
  icons: Array<Icon>;
  imageStepUpload: ImageStepUpload;
  librarySteps: Array<Step>;
  module: Module;
  modules: Array<Module>;
  /** Effective allocations for a specific library-reference placement (its local rows). */
  placementArticleAllocations: Array<ArticleAllocation>;
  /** Inputs local to a specific library-reference placement. */
  placementStepInputs: Array<StepInput>;
  /** Outputs local to a specific library-reference placement. */
  placementStepOutputs: Array<StepOutput>;
  /** Tool ids local to a specific library-reference placement. */
  placementToolIds: Array<Scalars['ID']['output']>;
  /** Tools local to a specific library-reference placement. */
  placementTools: Array<Tool>;
  product: Product;
  productConfiguration: ProductConfiguration;
  products: Array<Product>;
  step: Step;
  stepDiff?: Maybe<StepDiff>;
  stepInput: StepInput;
  stepOutput: StepOutput;
  stepTypes: Array<StepType>;
  steps?: Maybe<Array<Step>>;
  videoStepUpload: VideoStepUpload;
};


export type ProductRootBopArgs = {
  id: Scalars['ID']['input'];
};


export type ProductRootBopUploadArgs = {
  id: Scalars['ID']['input'];
};


export type ProductRootCheckConfigurationsArgs = {
  stepId: Scalars['ID']['input'];
};


export type ProductRootImageStepUploadArgs = {
  id: Scalars['ID']['input'];
};


export type ProductRootModuleArgs = {
  id: Scalars['ID']['input'];
};


export type ProductRootModulesArgs = {
  productId: Scalars['ID']['input'];
};


export type ProductRootPlacementArticleAllocationsArgs = {
  graphNodeStepId: Scalars['ID']['input'];
};


export type ProductRootPlacementStepInputsArgs = {
  graphNodeStepId: Scalars['ID']['input'];
};


export type ProductRootPlacementStepOutputsArgs = {
  graphNodeStepId: Scalars['ID']['input'];
};


export type ProductRootPlacementToolIdsArgs = {
  graphNodeStepId: Scalars['ID']['input'];
};


export type ProductRootPlacementToolsArgs = {
  graphNodeStepId: Scalars['ID']['input'];
};


export type ProductRootProductArgs = {
  id: Scalars['ID']['input'];
};


export type ProductRootProductConfigurationArgs = {
  id: Scalars['ID']['input'];
};


export type ProductRootStepArgs = {
  id: Scalars['ID']['input'];
};


export type ProductRootStepDiffArgs = {
  bopId: Scalars['ID']['input'];
  moduleId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
};


export type ProductRootStepInputArgs = {
  id: Scalars['ID']['input'];
};


export type ProductRootStepOutputArgs = {
  id: Scalars['ID']['input'];
};


export type ProductRootStepsArgs = {
  productId: Scalars['ID']['input'];
};


export type ProductRootVideoStepUploadArgs = {
  id: Scalars['ID']['input'];
};

export type ProductUploadUsageLocation = UploadUsageLocationI & {
  __typename?: 'ProductUploadUsageLocation';
  product: Product;
  type: UploadUsageType;
};

export type ProductionBatch = {
  __typename?: 'ProductionBatch';
  assignedUser?: Maybe<User>;
  bop: Bop;
  completed: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['Instant']['output']>;
  currentStep?: Maybe<Step>;
  durationInSeconds?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  module: Module;
  poNumber: Scalars['String']['output'];
  serialNumbers: Array<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['Instant']['output']>;
};

export type ProductionBatchPage = {
  __typename?: 'ProductionBatchPage';
  data: Array<ProductionBatch>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  itemsPerPage: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  totalItems: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ProductionBatchQuery = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  itemsPerPage: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  poNumberContains?: InputMaybe<Scalars['String']['input']>;
  serialNumberContains?: InputMaybe<Scalars['String']['input']>;
};

export type PromoteStepToModule = {
  abbreviation: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  graphNodeStepId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  account: AccountRoot;
  article: ArticleRoot;
  exception: Scalars['Boolean']['output'];
  issue: IssueRoot;
  product: ProductRoot;
  shopFloor: ShopFloorRoot;
  site: SiteRoot;
  upload: UploadRoot;
};

/** A removed step as it was in the last-seen version, placed relative to the current tree */
export type RemovedStep = {
  __typename?: 'RemovedStep';
  /** Current id of the surviving sibling it followed, null when it led its group */
  afterStepId?: Maybe<Scalars['ID']['output']>;
  /** Current id of the section step it sat under, null when at module root or when the section is gone */
  parentStepId?: Maybe<Scalars['ID']['output']>;
  step: Step;
};

export type ReplaceEbomPartAllocation = {
  newEbomPartId: Scalars['ID']['input'];
  oldEbomPartId: Scalars['ID']['input'];
};

export type ReplaceEbomPartAllocationsCommand = {
  replacements: Array<ReplaceEbomPartAllocation>;
};

export type SaveImageStepUploadEdit = {
  /** Opaque, client-authored editor state needed to re-edit the original. */
  editLayer: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  /** The edited image rendered by the client, shown in place of the original. */
  uploadId: Scalars['ID']['input'];
};

export type SaveStepArticleTransforms = {
  stepId: Scalars['ID']['input'];
  transforms: Array<StepArticleTransformInput>;
};

export type SaveStepViewport = {
  cameraX: Scalars['Float']['input'];
  cameraY: Scalars['Float']['input'];
  cameraZ: Scalars['Float']['input'];
  stepId: Scalars['ID']['input'];
  targetX: Scalars['Float']['input'];
  targetY: Scalars['Float']['input'];
  targetZ: Scalars['Float']['input'];
};

export type SerialNumberIssueLink = IssueLinkI & {
  __typename?: 'SerialNumberIssueLink';
  bop: Bop;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: Issue;
  module: Module;
  poNumber: Scalars['String']['output'];
  serialNumber: Scalars['String']['output'];
  step: Step;
};

export type SetConfirmCheckCommand = {
  checkConfigurationId: Scalars['ID']['input'];
  confirmed: Scalars['Boolean']['input'];
  poNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};

export type SetDagGraph = {
  entityId: Scalars['ID']['input'];
  nodes: Array<SetDagGraphNode>;
};

export type SetDagGraphNode = {
  entityId: Scalars['ID']['input'];
  entityType: GraphEntityType;
  id: Scalars['ID']['input'];
  parentIds: Array<Scalars['ID']['input']>;
};

export type SetFileUploadCheckCommand = {
  checkConfigurationId: Scalars['ID']['input'];
  poNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
  uploadId: Scalars['ID']['input'];
};

export type SetIssueLabels = {
  issueId: Scalars['ID']['input'];
  labelIds: Array<Scalars['ID']['input']>;
};

export type SetIssueResolved = {
  id: Scalars['ID']['input'];
  resolved: Scalars['Boolean']['input'];
};

export type SetNumericCheckCommand = {
  checkConfigurationId: Scalars['ID']['input'];
  milliQuantity: Scalars['Int']['input'];
  poNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};

export type SetOrganizationPermissions = {
  orgId: Scalars['ID']['input'];
  permissions: Array<PermissionOrganization>;
  userId: Scalars['ID']['input'];
};

export type SetPlacementTools = {
  graphNodeStepId: Scalars['ID']['input'];
  toolIds: Array<Scalars['ID']['input']>;
};

export type SetStepArticleVisibility = {
  stepId: Scalars['ID']['input'];
  visibility: StepArticleVisibility;
};

export type SetStepDuration = {
  durationInSeconds: Scalars['Int']['input'];
  stepId: Scalars['ID']['input'];
};

export type SetStepDurations = {
  durations: Array<SetStepDuration>;
};

export type SetStepIcons = {
  iconIds: Array<Scalars['ID']['input']>;
  stepId: Scalars['ID']['input'];
};

export type SetStepPreferred3dModel = {
  bopUploadId?: InputMaybe<Scalars['ID']['input']>;
  stepId: Scalars['ID']['input'];
};

export type SetStringCheckCommand = {
  checkConfigurationId: Scalars['ID']['input'];
  poNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type SetTreeGraph = {
  entityId: Scalars['ID']['input'];
  nodes: Array<SetTreeGraphNode>;
};

export type SetTreeGraphNode = {
  entityId: Scalars['ID']['input'];
  entityType: GraphEntityType;
  id: Scalars['ID']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type SetUserPermissions = {
  permissions: Array<PermissionUser>;
  userId: Scalars['ID']['input'];
};

export type ShopFloorMutationRoot = {
  __typename?: 'ShopFloorMutationRoot';
  createProductionBatch: ProductionBatch;
  deleteCheck: Scalars['Boolean']['output'];
  deleteProductionBatch: Scalars['ID']['output'];
  markModuleViewed: Scalars['Boolean']['output'];
  setConfirmCheck: ConfirmCheck;
  setFileUploadCheck: FileUploadCheck;
  setNumericCheck: NumericCheck;
  setStringCheck: StringCheck;
  transferProductionBatch: ProductionBatch;
  updateProductionBatch: ProductionBatch;
};


export type ShopFloorMutationRootCreateProductionBatchArgs = {
  command: CreateProductionBatchCommand;
};


export type ShopFloorMutationRootDeleteCheckArgs = {
  command: DeleteCheckCommand;
};


export type ShopFloorMutationRootDeleteProductionBatchArgs = {
  id: Scalars['ID']['input'];
};


export type ShopFloorMutationRootMarkModuleViewedArgs = {
  bopId: Scalars['ID']['input'];
  moduleId: Scalars['ID']['input'];
};


export type ShopFloorMutationRootSetConfirmCheckArgs = {
  command: SetConfirmCheckCommand;
};


export type ShopFloorMutationRootSetFileUploadCheckArgs = {
  command: SetFileUploadCheckCommand;
};


export type ShopFloorMutationRootSetNumericCheckArgs = {
  command: SetNumericCheckCommand;
};


export type ShopFloorMutationRootSetStringCheckArgs = {
  command: SetStringCheckCommand;
};


export type ShopFloorMutationRootTransferProductionBatchArgs = {
  command: TransferProductionBatchCommand;
};


export type ShopFloorMutationRootUpdateProductionBatchArgs = {
  command: UpdateProductionBatchCommand;
};

export type ShopFloorRoot = {
  __typename?: 'ShopFloorRoot';
  check: Check;
  checks: Array<Check>;
  productionBatch?: Maybe<ProductionBatch>;
  productionBatches: ProductionBatchPage;
  productionBatchesInProgressForCurrentUser: Array<ProductionBatch>;
  productionBatchesInProgressForUser: Array<ProductionBatch>;
};


export type ShopFloorRootCheckArgs = {
  id: Scalars['ID']['input'];
};


export type ShopFloorRootChecksArgs = {
  query?: InputMaybe<CheckSearchQuery>;
};


export type ShopFloorRootProductionBatchArgs = {
  id: Scalars['ID']['input'];
};


export type ShopFloorRootProductionBatchesArgs = {
  query: ProductionBatchQuery;
};


export type ShopFloorRootProductionBatchesInProgressForUserArgs = {
  userId: Scalars['ID']['input'];
};

export type Site = {
  __typename?: 'Site';
  abbreviation: Scalars['String']['output'];
  archived: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tools: Array<Tool>;
};

export type SiteMutationRoot = {
  __typename?: 'SiteMutationRoot';
  createSite: Site;
  createTool: Tool;
  deleteSite: Scalars['ID']['output'];
  deleteTool: Scalars['ID']['output'];
  updateSite: Site;
  updateTool: Tool;
};


export type SiteMutationRootCreateSiteArgs = {
  command: CreateSite;
};


export type SiteMutationRootCreateToolArgs = {
  command: CreateTool;
};


export type SiteMutationRootDeleteSiteArgs = {
  id: Scalars['ID']['input'];
};


export type SiteMutationRootDeleteToolArgs = {
  id: Scalars['ID']['input'];
};


export type SiteMutationRootUpdateSiteArgs = {
  command: UpdateSite;
};


export type SiteMutationRootUpdateToolArgs = {
  command: UpdateTool;
};

export type SiteRoot = {
  __typename?: 'SiteRoot';
  site: Site;
  sites: Array<Site>;
  tool: Tool;
};


export type SiteRootSiteArgs = {
  id: Scalars['ID']['input'];
};


export type SiteRootToolArgs = {
  id: Scalars['ID']['input'];
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Step = {
  __typename?: 'Step';
  activeBopUpload?: Maybe<BopUpload>;
  articleAllocations: Array<ArticleAllocation>;
  articleTransforms: Array<StepArticleTransform>;
  articleVisibility: StepArticleVisibility;
  checkConfigurations: Array<CheckConfiguration>;
  durationInSeconds: Scalars['Int']['output'];
  /** Icons shown to the operator, in display order */
  icons: Array<Icon>;
  id: Scalars['ID']['output'];
  inputs: Array<StepInput>;
  instructionText?: Maybe<Scalars['String']['output']>;
  issueLinks: Array<IssueLink>;
  library: Scalars['Boolean']['output'];
  /** Icons still linked to this step that were deleted from the library */
  missingIcons: Array<Icon>;
  module?: Maybe<Module>;
  name: Scalars['String']['output'];
  outputs: Array<StepOutput>;
  /** The 3D model an editor selected for this step; null while the automatic choice applies. */
  preferredBopUploadId?: Maybe<Scalars['ID']['output']>;
  stepType: StepType;
  toolIds: Array<Scalars['ID']['output']>;
  tools: Array<Tool>;
  updatedAt: Scalars['Instant']['output'];
  uploads: Array<StepUpload>;
  usageCount: Scalars['Int']['output'];
  usages: Array<StepUsage>;
  viewport?: Maybe<StepViewport>;
  warningText?: Maybe<Scalars['String']['output']>;
};

export type StepArticleTransform = {
  __typename?: 'StepArticleTransform';
  articleId: Scalars['ID']['output'];
  instanceIndex: Scalars['Int']['output'];
  positionX: Scalars['Float']['output'];
  positionY: Scalars['Float']['output'];
  positionZ: Scalars['Float']['output'];
  rotationW: Scalars['Float']['output'];
  rotationX: Scalars['Float']['output'];
  rotationY: Scalars['Float']['output'];
  rotationZ: Scalars['Float']['output'];
};

export type StepArticleTransformInput = {
  articleId: Scalars['ID']['input'];
  instanceIndex: Scalars['Int']['input'];
  positionX: Scalars['Float']['input'];
  positionY: Scalars['Float']['input'];
  positionZ: Scalars['Float']['input'];
  rotationW: Scalars['Float']['input'];
  rotationX: Scalars['Float']['input'];
  rotationY: Scalars['Float']['input'];
  rotationZ: Scalars['Float']['input'];
};

/** Which previously-allocated articles the 3D viewer shows for a step. */
export enum StepArticleVisibility {
  /** Show all articles allocated to any earlier step in the module. */
  AllPrevious = 'ALL_PREVIOUS',
  /** Show only the articles allocated to the current step. */
  HidePrevious = 'HIDE_PREVIOUS',
  /** Show every article in the 3D model. */
  ShowAll = 'SHOW_ALL',
  /** Show only the articles allocated to earlier steps within the same group of substeps. */
  ShowSubmodule = 'SHOW_SUBMODULE'
}

/** A step field the change tracker compares between BOP versions */
export enum StepChangeField {
  ArticleAllocations = 'ARTICLE_ALLOCATIONS',
  CheckConfigurations = 'CHECK_CONFIGURATIONS',
  DurationInSeconds = 'DURATION_IN_SECONDS',
  Icons = 'ICONS',
  Inputs = 'INPUTS',
  InstructionText = 'INSTRUCTION_TEXT',
  Name = 'NAME',
  Outputs = 'OUTPUTS',
  StepType = 'STEP_TYPE',
  Tools = 'TOOLS',
  Uploads = 'UPLOADS',
  WarningText = 'WARNING_TEXT'
}

/** Whether a step appeared, went away, changed place, or had some of its fields edited */
export enum StepChangeKind {
  Added = 'ADDED',
  Modified = 'MODIFIED',
  Moved = 'MOVED',
  Removed = 'REMOVED'
}

/** The diff between a step's current version and the version the operator last saw */
export type StepDiff = {
  __typename?: 'StepDiff';
  /** Empty unless the kind is MODIFIED */
  changedFields: Array<StepChangeField>;
  currentStep: Step;
  kind: StepChangeKind;
  previousStep?: Maybe<Step>;
};

export type StepImageUploadUsageLocation = UploadUsageLocationI & {
  __typename?: 'StepImageUploadUsageLocation';
  bop?: Maybe<Bop>;
  module?: Maybe<Module>;
  step: Step;
  type: UploadUsageType;
};

export type StepInput = {
  __typename?: 'StepInput';
  /** The EBOM parts making up this input's article: everything allocated in the producing module up to and including the output's step. The 3D viewer highlights them together as one input. */
  contentArticlePaths: Array<ArticlePath>;
  id: Scalars['ID']['output'];
  milliQuantity: Scalars['Int']['output'];
  module: Module;
  output: StepOutput;
  step: Step;
};

export type StepIssueLink = IssueLinkI & {
  __typename?: 'StepIssueLink';
  bop: Bop;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: Issue;
  module: Module;
  step: Step;
};

export type StepNode = TreeNode & {
  __typename?: 'StepNode';
  /** How this step changed since the operator last viewed this module's BOP. Null when unchanged or not queried in a BOP context. */
  changeKind?: Maybe<StepChangeKind>;
  /** Allocations effective for this placement: the step's own allocations, overlaid with the placement's local rows for library references. */
  effectiveArticleAllocations: Array<ArticleAllocation>;
  /** Inputs effective for this placement: the placement's local rows for library references, otherwise the step's own inputs. */
  effectiveInputs: Array<StepInput>;
  /** Outputs effective for this placement: the placement's local rows for library references, otherwise the step's own outputs. */
  effectiveOutputs: Array<StepOutput>;
  id: Scalars['ID']['output'];
  isLibraryReference: Scalars['Boolean']['output'];
  /** For a MOVED step, its 1-based numbering path in the last-seen version */
  movedFrom?: Maybe<Array<Scalars['Int']['output']>>;
  parentId?: Maybe<Scalars['ID']['output']>;
  step: Step;
};

export type StepOutput = {
  __typename?: 'StepOutput';
  article: Article;
  id: Scalars['ID']['output'];
  milliQuantity: Scalars['Int']['output'];
  module?: Maybe<Module>;
  step: Step;
};

export type StepProposal = {
  __typename?: 'StepProposal';
  checkProposals: Array<CheckProposal>;
  durationInSeconds: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  instructionText?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  uploadProposals: Array<StepUploadProposal>;
};

export type StepProposalResult = {
  __typename?: 'StepProposalResult';
  errors: Array<Scalars['String']['output']>;
  proposals: Array<StepProposal>;
};

export type StepType = {
  __typename?: 'StepType';
  archived: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  released: Scalars['Boolean']['output'];
};

export type StepUpload = ImageStepUpload | VideoStepUpload;

export type StepUploadProposal = {
  __typename?: 'StepUploadProposal';
  fragmentEndInMillis?: Maybe<Scalars['Int']['output']>;
  fragmentStartInMillis?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  upload: Upload;
};

export type StepUploadUsageLocation = UploadUsageLocationI & {
  __typename?: 'StepUploadUsageLocation';
  bop?: Maybe<Bop>;
  module?: Maybe<Module>;
  step: Step;
  type: UploadUsageType;
};

export type StepUsage = {
  __typename?: 'StepUsage';
  bop: Bop;
  module: Module;
  step: Step;
};

export type StepViewport = {
  __typename?: 'StepViewport';
  cameraX: Scalars['Float']['output'];
  cameraY: Scalars['Float']['output'];
  cameraZ: Scalars['Float']['output'];
  targetX: Scalars['Float']['output'];
  targetY: Scalars['Float']['output'];
  targetZ: Scalars['Float']['output'];
};

export type StringCheck = CheckI & {
  __typename?: 'StringCheck';
  configuration: CheckConfiguration;
  createdAt: Scalars['Instant']['output'];
  id: Scalars['ID']['output'];
  poNumber: Scalars['String']['output'];
  released: Scalars['Boolean']['output'];
  reportingUser: User;
  serialNumber: Scalars['String']['output'];
  text: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Instant']['output']>;
};

export type Tool = {
  __typename?: 'Tool';
  archived: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUploads: Array<Upload>;
  name: Scalars['String']['output'];
  released: Scalars['Boolean']['output'];
};

export type ToolImageUploadUsageLocation = UploadUsageLocationI & {
  __typename?: 'ToolImageUploadUsageLocation';
  site?: Maybe<Site>;
  tool: Tool;
  type: UploadUsageType;
};

export type TransferProductionBatchCommand = {
  assignedUserId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type TreeGraph = {
  nodes: Array<TreeNode>;
};

export type TreeNode = {
  id: Scalars['ID']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
};

export type UnlinkLibraryStep = {
  moduleId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
};

export type UpdateArticle = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  unit: ArticleUnit;
};

export type UpdateCheckConfigurationCommand = {
  allowedMimeTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  isRequired: Scalars['Boolean']['input'];
  lowerLimit?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  upperLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateIcon = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateImageStepUpload = {
  caption?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateIssue = {
  assignedToUserIds: Array<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  resolved: Scalars['Boolean']['input'];
  uploadIds: Array<Scalars['ID']['input']>;
};

export type UpdateIssueComment = {
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  resolved: Scalars['Boolean']['input'];
  uploadIds: Array<Scalars['ID']['input']>;
};

export type UpdateIssueLabel = {
  color?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateIssueLink = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateModule = {
  abbreviation: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateOrganization = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type UpdateProduct = {
  abbreviation: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageUploadId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateProductConfiguration = {
  abbreviation: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageUploadId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateProductionBatchCommand = {
  assignedUserId?: InputMaybe<Scalars['ID']['input']>;
  completed: Scalars['Boolean']['input'];
  currentStepId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateSite = {
  abbreviation: Scalars['String']['input'];
  archived: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateStep = {
  durationInSeconds: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  instructionText?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  stepTypeId: Scalars['ID']['input'];
  toolIds: Array<Scalars['ID']['input']>;
  warningText?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStepInput = {
  id: Scalars['ID']['input'];
  milliQuantity: Scalars['Int']['input'];
};

export type UpdateStepOutput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  milliQuantity: Scalars['Int']['input'];
};

export type UpdateStepType = {
  archived: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateTool = {
  archived: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageUploadIds: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateUpload = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateUser = {
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  lastname: Scalars['String']['input'];
};

export type UpdateVideoStepUpload = {
  caption?: InputMaybe<Scalars['String']['input']>;
  fragmentEndInMillis?: InputMaybe<Scalars['Int']['input']>;
  fragmentLoop?: InputMaybe<Scalars['Boolean']['input']>;
  fragmentStartInMillis?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
};

export type Upload = {
  __typename?: 'Upload';
  contentType: Scalars['String']['output'];
  createdAt: Scalars['Instant']['output'];
  extension: UploadExtension;
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
  usageLocations: Array<UploadUsageLocation>;
};


export type UploadImageUrlArgs = {
  options: ImageOptions;
};

export type UploadExtension = CsvExtension | GenericExtension | ImageExtension | ModelExtension | PdfExtension | VideoExtension;

export type UploadMutationRoot = {
  __typename?: 'UploadMutationRoot';
  createMultipartUpload: Scalars['ID']['output'];
  createSnapshotUpload: Upload;
  deleteUpload: Scalars['ID']['output'];
  finalizeMultipartUpload: Upload;
  updateUpload: Upload;
};


export type UploadMutationRootCreateMultipartUploadArgs = {
  command: CreateMultipartUpload;
};


export type UploadMutationRootCreateSnapshotUploadArgs = {
  command: CreateSnapshotUpload;
};


export type UploadMutationRootDeleteUploadArgs = {
  id: Scalars['ID']['input'];
};


export type UploadMutationRootFinalizeMultipartUploadArgs = {
  id: Scalars['ID']['input'];
};


export type UploadMutationRootUpdateUploadArgs = {
  command: UpdateUpload;
};

export type UploadQuery = {
  inContentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  notInContentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  page: Scalars['Int']['input'];
  results: Scalars['Int']['input'];
  sortBy: UploadSortField;
  sortDirection: UploadSortDirection;
};

export type UploadRoot = {
  __typename?: 'UploadRoot';
  allUploads: Array<Upload>;
  search: Array<Upload>;
  upload: Upload;
  uploads: Array<Upload>;
};


export type UploadRootSearchArgs = {
  query: UploadQuery;
};


export type UploadRootUploadArgs = {
  id: Scalars['ID']['input'];
};


export type UploadRootUploadsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export enum UploadSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum UploadSortField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME'
}

export type UploadUsageLocation = BopUploadUsageLocation | CheckUploadUsageLocation | IconUploadUsageLocation | IssueCommentUploadUsageLocation | IssueUploadUsageLocation | ProductConfigurationUploadUsageLocation | ProductUploadUsageLocation | StepImageUploadUsageLocation | StepUploadUsageLocation | ToolImageUploadUsageLocation;

export type UploadUsageLocationI = {
  type: UploadUsageType;
};

export enum UploadUsageType {
  BopUpload = 'BOP_UPLOAD',
  Check = 'CHECK',
  Icon = 'ICON',
  Issue = 'ISSUE',
  IssueComment = 'ISSUE_COMMENT',
  Product = 'PRODUCT',
  ProductConfiguration = 'PRODUCT_CONFIGURATION',
  StepImage = 'STEP_IMAGE',
  StepUpload = 'STEP_UPLOAD',
  ToolImage = 'TOOL_IMAGE'
}

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastname: Scalars['String']['output'];
};

export type UserSearchCriteria = {
  contains?: InputMaybe<Scalars['String']['input']>;
};

export enum VersionStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Released = 'RELEASED',
  Review = 'REVIEW'
}

export type VideoExtension = {
  __typename?: 'VideoExtension';
  url: Scalars['String']['output'];
};

export type VideoStepUpload = IStepUpload & {
  __typename?: 'VideoStepUpload';
  caption?: Maybe<Scalars['String']['output']>;
  fragmentEndInMillis?: Maybe<Scalars['Int']['output']>;
  fragmentLoop?: Maybe<Scalars['Boolean']['output']>;
  fragmentStartInMillis?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** Re-encoded copy containing only the fragment, available once the step is released and trimming has finished */
  trimmedUpload?: Maybe<Upload>;
  upload: Upload;
};

export type BreadcrumbDataQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
  includeProduct: Scalars['Boolean']['input'];
  configId: Scalars['ID']['input'];
  includeConfig: Scalars['Boolean']['input'];
  siteId: Scalars['ID']['input'];
  includeSite: Scalars['Boolean']['input'];
  bopId: Scalars['ID']['input'];
  includeBop: Scalars['Boolean']['input'];
  includeModules: Scalars['Boolean']['input'];
  includeEboms: Scalars['Boolean']['input'];
  stepId: Scalars['ID']['input'];
  includeStep: Scalars['Boolean']['input'];
}>;


export type BreadcrumbDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', product?: { __typename?: 'Product', id: string, name: string }, productConfiguration?: { __typename?: 'ProductConfiguration', id: string, name: string }, bop?: { __typename?: 'BOP', id: string, version: number, versionStatus: VersionStatus, nodes?: Array<{ __typename?: 'ModuleNode', module: { __typename?: 'Module', id: string, name: string } }> }, step?: { __typename?: 'Step', id: string, name: string } }, site: { __typename?: 'SiteRoot', site?: { __typename?: 'Site', id: string, name: string } }, article: { __typename?: 'ArticleRoot', ebomsForBop?: Array<{ __typename?: 'Ebom', id: string, name: string }> } };

export type TestExceptionQueryVariables = Exact<{ [key: string]: never; }>;


export type TestExceptionQuery = { __typename?: 'Query', exception: boolean };

export type ArchivedConfigurationAlertDataQueryVariables = Exact<{
  productConfigurationId: Scalars['ID']['input'];
}>;


export type ArchivedConfigurationAlertDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', productConfiguration: { __typename?: 'ProductConfiguration', id: string, archived: boolean, product: { __typename?: 'Product', id: string } } } };

export type ArticleAllocationListDataQueryVariables = Exact<{
  stepId: Scalars['ID']['input'];
}>;


export type ArticleAllocationListDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', step: { __typename?: 'Step', articleAllocations: Array<{ __typename: 'EbomPartAllocation', id: string, milliQuantity: number, article: { __typename?: 'Article', id: string, articleNumber: string, revision: string, name?: string, unit: ArticleUnit, type: ArticleType }, ebomPart: { __typename?: 'EbomPart', id: string, ebomId: string, articleNumber: string, revision: string, name?: string, unit: ArticleUnit, milliQuantity: number, articlePath: { __typename?: 'ArticlePath', articleNumbers: Array<string> }, stepAllocations: Array<{ __typename?: 'EbomPartAllocation', id: string, milliQuantity: number }> } } | { __typename: 'ManualArticleAllocation', id: string, milliQuantity: number, article: { __typename?: 'Article', id: string, articleNumber: string, revision: string, name?: string, unit: ArticleUnit, type: ArticleType } }> } } };

export type ArticleAllocationListPlacementDataQueryVariables = Exact<{
  graphNodeStepId: Scalars['ID']['input'];
}>;


export type ArticleAllocationListPlacementDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', placementArticleAllocations: Array<{ __typename: 'EbomPartAllocation', id: string, milliQuantity: number, article: { __typename?: 'Article', id: string, articleNumber: string, revision: string, name?: string, unit: ArticleUnit, type: ArticleType }, ebomPart: { __typename?: 'EbomPart', id: string, ebomId: string, articleNumber: string, revision: string, name?: string, unit: ArticleUnit, milliQuantity: number, articlePath: { __typename?: 'ArticlePath', articleNumbers: Array<string> }, stepAllocations: Array<{ __typename?: 'EbomPartAllocation', id: string, milliQuantity: number }> } } | { __typename: 'ManualArticleAllocation', id: string, milliQuantity: number, article: { __typename?: 'Article', id: string, articleNumber: string, revision: string, name?: string, unit: ArticleUnit, type: ArticleType } }> } };

export type PartAllocationListAllocationMutationMutationVariables = Exact<{
  command: AllocateArticleToStepCommand;
}>;


export type PartAllocationListAllocationMutationMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', allocateArticleToStep: boolean } };

export type ArticleAllocationListSetEbomAllocationMutationVariables = Exact<{
  command: AllocateEbomPartToStepCommand;
}>;


export type ArticleAllocationListSetEbomAllocationMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', allocateEbomPartToStep: boolean } };

export type CreateArticleDialogTakenQueryVariables = Exact<{
  articleNumber: Scalars['String']['input'];
  revision: Scalars['String']['input'];
}>;


export type CreateArticleDialogTakenQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', articles: Array<{ __typename?: 'Article', id: string }> } };

export type ArticleViewCreateArticleMutationVariables = Exact<{
  command: CreateArticle;
}>;


export type ArticleViewCreateArticleMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', createArticle: { __typename?: 'Article', id: string, articleNumber: string, revision: string, name?: string } } };

export type EbomPartAllocationRowDataQueryVariables = Exact<{
  bopId: Scalars['ID']['input'];
}>;


export type EbomPartAllocationRowDataQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', ebomsForBop: Array<{ __typename?: 'Ebom', id: string, name: string }> } };

export type EbomPartAllocationRowAllocationMutationVariables = Exact<{
  command: AllocateEbomPartToStepCommand;
}>;


export type EbomPartAllocationRowAllocationMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', allocateEbomPartToStep: boolean } };

export type ManualArticleAllocationRowAllocationMutationVariables = Exact<{
  command: AllocateArticleToStepCommand;
}>;


export type ManualArticleAllocationRowAllocationMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', allocateArticleToStep: boolean } };

export type BopModulesTimeChartDataQueryVariables = Exact<{
  bopId: Scalars['ID']['input'];
}>;


export type BopModulesTimeChartDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', bop: { __typename?: 'BOP', nodes: Array<{ __typename?: 'ModuleNode', module: { __typename?: 'Module', id: string, name: string, nodes: Array<{ __typename?: 'StepNode', id: string, step: { __typename?: 'Step', id: string, name: string, durationInSeconds: number } }> } }> } } };

export type BopNavigationDrawerDataQueryVariables = Exact<{
  bopId: Scalars['ID']['input'];
  includeIssues: Scalars['Boolean']['input'];
  includeEboms: Scalars['Boolean']['input'];
}>;


export type BopNavigationDrawerDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', bop: { __typename?: 'BOP', id: string, versionStatus: VersionStatus, productConfiguration: { __typename?: 'ProductConfiguration', id: string, archived: boolean }, issueLinks?: Array<{ __typename?: 'ArticleIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any, assignedToUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }>, labels: Array<{ __typename?: 'IssueLabel', id: string, name: string, color: string }> } } | { __typename?: 'BOPIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any, assignedToUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }>, labels: Array<{ __typename?: 'IssueLabel', id: string, name: string, color: string }> } } | { __typename?: 'ModuleIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any, assignedToUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }>, labels: Array<{ __typename?: 'IssueLabel', id: string, name: string, color: string }> } } | { __typename?: 'SerialNumberIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any, assignedToUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }>, labels: Array<{ __typename?: 'IssueLabel', id: string, name: string, color: string }> } } | { __typename?: 'StepIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any, assignedToUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }>, labels: Array<{ __typename?: 'IssueLabel', id: string, name: string, color: string }> } }> } }, article: { __typename?: 'ArticleRoot', ebomsForBop?: Array<{ __typename?: 'Ebom', id: string, name: string, sourceType: EbomSourceType, sourceId: string }> } };

export type DeleteEbomMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteEbomMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', deleteEbom: string } };

export type BopReleaseConfirmationDataQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
  productConfigurationId: Scalars['ID']['input'];
  bopId: Scalars['ID']['input'];
}>;


export type BopReleaseConfirmationDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', product: { __typename?: 'Product', name: string }, productConfiguration: { __typename?: 'ProductConfiguration', name: string }, bop: { __typename?: 'BOP', version: number, site: { __typename?: 'Site', id: string, name: string } } } };

export type BopReleaseConfirmationReleaseMutationVariables = Exact<{
  configId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
}>;


export type BopReleaseConfirmationReleaseMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', releaseLatestBOPVersion: { __typename?: 'BOP', id: string } } };

export type BopStepViewerDataQueryVariables = Exact<{
  bopId: Scalars['ID']['input'];
  moduleId: Scalars['ID']['input'];
  includeEboms: Scalars['Boolean']['input'];
}>;


export type BopStepViewerDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', bop: { __typename?: 'BOP', id: string, uploads: Array<{ __typename?: 'BOPUpload', id: string, glbStatus: GlbStatus, glbUpload?: { __typename?: 'Upload', id: string, url: string }, upload: { __typename?: 'Upload', id: string, name: string } }> }, module: { __typename?: 'Module', id: string, nodes: Array<{ __typename?: 'StepNode', id: string, parentId?: string, effectiveArticleAllocations: Array<{ __typename: 'EbomPartAllocation', milliQuantity: number, instanceIndexes?: Array<number>, article: { __typename?: 'Article', id: string, articleNumber: string, name?: string, type: ArticleType }, ebomPart: { __typename?: 'EbomPart', id: string, articlePath: { __typename?: 'ArticlePath', articleNumbers: Array<string> } } } | { __typename: 'ManualArticleAllocation', milliQuantity: number, article: { __typename?: 'Article', id: string, articleNumber: string, name?: string, type: ArticleType } }>, effectiveInputs: Array<{ __typename?: 'StepInput', id: string, milliQuantity: number, output: { __typename?: 'StepOutput', id: string, article: { __typename?: 'Article', articleNumber: string } }, contentArticlePaths: Array<{ __typename?: 'ArticlePath', articleNumbers: Array<string> }> }>, effectiveOutputs: Array<{ __typename?: 'StepOutput', article: { __typename?: 'Article', articleNumber: string } }>, step: { __typename?: 'Step', id: string, preferredBopUploadId?: string, articleVisibility: StepArticleVisibility, viewport?: { __typename?: 'StepViewport', cameraX: number, cameraY: number, cameraZ: number, targetX: number, targetY: number, targetZ: number }, articleTransforms: Array<{ __typename?: 'StepArticleTransform', articleId: string, instanceIndex: number, positionX: number, positionY: number, positionZ: number, rotationX: number, rotationY: number, rotationZ: number, rotationW: number }>, activeBopUpload?: { __typename?: 'BOPUpload', id: string, glbStatus: GlbStatus, glbUpload?: { __typename?: 'Upload', id: string, url: string } } } }> } }, article: { __typename?: 'ArticleRoot', ebomsForBop?: Array<{ __typename?: 'Ebom', id: string, name: string, bopUpload?: { __typename?: 'BOPUpload', id: string }, ebomParts: Array<{ __typename?: 'EbomPart', id: string, articleNumber: string }> }> } };

export type BopStepViewerEbomPartsQueryVariables = Exact<{
  bopId: Scalars['ID']['input'];
}>;


export type BopStepViewerEbomPartsQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', ebomsForBop: Array<{ __typename?: 'Ebom', id: string, bopUpload?: { __typename?: 'BOPUpload', id: string }, ebomParts: Array<{ __typename?: 'EbomPart', id: string, parentId?: string, milliQuantity: number, article?: { __typename?: 'Article', id: string }, articlePath: { __typename?: 'ArticlePath', articleNumbers: Array<string> } }> }> } };

export type BopStepViewerAllocateEbomPartMutationVariables = Exact<{
  command: AllocateEbomPartToStepCommand;
}>;


export type BopStepViewerAllocateEbomPartMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', allocateEbomPartToStep: boolean } };

export type SaveStepViewportMutationVariables = Exact<{
  command: SaveStepViewport;
}>;


export type SaveStepViewportMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', saveStepViewport: { __typename?: 'StepViewport', cameraX: number, cameraY: number, cameraZ: number, targetX: number, targetY: number, targetZ: number } } };

export type BopStepViewerSetArticleVisibilityMutationVariables = Exact<{
  command: SetStepArticleVisibility;
}>;


export type BopStepViewerSetArticleVisibilityMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', setStepArticleVisibility: { __typename?: 'Step', id: string, articleVisibility: StepArticleVisibility } } };

export type BopStepViewerSetPreferred3dModelMutationVariables = Exact<{
  command: SetStepPreferred3dModel;
}>;


export type BopStepViewerSetPreferred3dModelMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', setStepPreferred3dModel: { __typename?: 'Step', id: string } } };

export type SaveStepArticleTransformsMutationVariables = Exact<{
  command: SaveStepArticleTransforms;
}>;


export type SaveStepArticleTransformsMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', saveStepArticleTransforms: Array<{ __typename?: 'StepArticleTransform', articleId: string }> } };

export type BopUploadsDataQueryVariables = Exact<{
  bopId: Scalars['ID']['input'];
}>;


export type BopUploadsDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', bop: { __typename?: 'BOP', uploads: Array<{ __typename?: 'BOPUpload', id: string, glbStatus: GlbStatus, inUse: boolean, upload: { __typename?: 'Upload', id: string, name: string, contentType: string } }> } } };

export type BopUploadsCreateMutationVariables = Exact<{
  command: CreateBopUpload;
}>;


export type BopUploadsCreateMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createBOPUpload: { __typename?: 'BOPUpload', id: string } } };

export type BopUploadsDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BopUploadsDeleteMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', deleteBOPUpload: string } };

export type CheckDialogDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CheckDialogDataQuery = { __typename?: 'Query', shopFloor: { __typename?: 'ShopFloorRoot', check: { __typename: 'ConfirmCheck', id: string, released: boolean, serialNumber: string, poNumber: string, createdAt: any, updatedAt?: any, confirmed: boolean, reportingUser: { __typename?: 'User', id: string, firstname: string, lastname: string }, configuration: { __typename?: 'CheckConfiguration', id: string, description: string, isRequired: boolean, lowerLimit?: number, upperLimit?: number, bop?: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } }, module?: { __typename?: 'Module', id: string, name: string }, step: { __typename?: 'Step', id: string, name: string } } } | { __typename: 'FileUploadCheck', id: string, released: boolean, serialNumber: string, poNumber: string, createdAt: any, updatedAt?: any, reportingUser: { __typename?: 'User', id: string, firstname: string, lastname: string }, configuration: { __typename?: 'CheckConfiguration', id: string, description: string, isRequired: boolean, lowerLimit?: number, upperLimit?: number, bop?: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } }, module?: { __typename?: 'Module', id: string, name: string }, step: { __typename?: 'Step', id: string, name: string } }, upload: { __typename?: 'Upload', id: string, name: string, url: string } } | { __typename: 'NumericCheck', id: string, released: boolean, serialNumber: string, poNumber: string, createdAt: any, updatedAt?: any, milliQuantity: number, reportingUser: { __typename?: 'User', id: string, firstname: string, lastname: string }, configuration: { __typename?: 'CheckConfiguration', id: string, description: string, isRequired: boolean, lowerLimit?: number, upperLimit?: number, bop?: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } }, module?: { __typename?: 'Module', id: string, name: string }, step: { __typename?: 'Step', id: string, name: string } } } | { __typename: 'StringCheck', id: string, released: boolean, serialNumber: string, poNumber: string, createdAt: any, updatedAt?: any, text: string, reportingUser: { __typename?: 'User', id: string, firstname: string, lastname: string }, configuration: { __typename?: 'CheckConfiguration', id: string, description: string, isRequired: boolean, lowerLimit?: number, upperLimit?: number, bop?: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } }, module?: { __typename?: 'Module', id: string, name: string }, step: { __typename?: 'Step', id: string, name: string } } } } };

export type ConfirmationCheckSetMutationVariables = Exact<{
  command: SetConfirmCheckCommand;
}>;


export type ConfirmationCheckSetMutation = { __typename?: 'Mutation', shopFloor: { __typename?: 'ShopFloorMutationRoot', setConfirmCheck: { __typename?: 'ConfirmCheck', id: string } } };

export type ConfirmationCheckDeleteMutationVariables = Exact<{
  command: DeleteCheckCommand;
}>;


export type ConfirmationCheckDeleteMutation = { __typename?: 'Mutation', shopFloor: { __typename?: 'ShopFloorMutationRoot', deleteCheck: boolean } };

export type FileUploadCheckSetMutationVariables = Exact<{
  command: SetFileUploadCheckCommand;
}>;


export type FileUploadCheckSetMutation = { __typename?: 'Mutation', shopFloor: { __typename?: 'ShopFloorMutationRoot', setFileUploadCheck: { __typename?: 'FileUploadCheck', id: string } } };

export type FileUploadCheckDeleteMutationVariables = Exact<{
  command: DeleteCheckCommand;
}>;


export type FileUploadCheckDeleteMutation = { __typename?: 'Mutation', shopFloor: { __typename?: 'ShopFloorMutationRoot', deleteCheck: boolean } };

export type NumericCheckSetMutationVariables = Exact<{
  command: SetNumericCheckCommand;
}>;


export type NumericCheckSetMutation = { __typename?: 'Mutation', shopFloor: { __typename?: 'ShopFloorMutationRoot', setNumericCheck: { __typename?: 'NumericCheck', id: string } } };

export type NumericCheckDeleteMutationVariables = Exact<{
  command: DeleteCheckCommand;
}>;


export type NumericCheckDeleteMutation = { __typename?: 'Mutation', shopFloor: { __typename?: 'ShopFloorMutationRoot', deleteCheck: boolean } };

export type CheckDataQueryVariables = Exact<{
  stepId: Scalars['ID']['input'];
}>;


export type CheckDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', checkConfigurations: Array<{ __typename?: 'CheckConfiguration', id: string, type: CheckType, isRequired: boolean, description: string, lowerLimit?: number, upperLimit?: number, unit?: string, allowedMimeTypes?: Array<string>, unreleasedChecks: Array<{ __typename?: 'ConfirmCheck', id: string, poNumber: string, serialNumber: string, confirmed: boolean } | { __typename?: 'FileUploadCheck', id: string, poNumber: string, serialNumber: string, upload: { __typename?: 'Upload', id: string, name: string, contentType: string } } | { __typename?: 'NumericCheck', id: string, poNumber: string, serialNumber: string, milliQuantity: number } | { __typename?: 'StringCheck', id: string, poNumber: string, serialNumber: string, text: string }> }> } };

export type StringCheckSetMutationVariables = Exact<{
  command: SetStringCheckCommand;
}>;


export type StringCheckSetMutation = { __typename?: 'Mutation', shopFloor: { __typename?: 'ShopFloorMutationRoot', setStringCheck: { __typename?: 'StringCheck', id: string } } };

export type StringCheckDeleteMutationVariables = Exact<{
  command: DeleteCheckCommand;
}>;


export type StringCheckDeleteMutation = { __typename?: 'Mutation', shopFloor: { __typename?: 'ShopFloorMutationRoot', deleteCheck: boolean } };

export type StepCheckConfigurationsDataQueryVariables = Exact<{
  stepId: Scalars['ID']['input'];
}>;


export type StepCheckConfigurationsDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', checkConfigurations: Array<{ __typename?: 'CheckConfiguration', id: string, type: CheckType, isRequired: boolean, description: string, upperLimit?: number, lowerLimit?: number, unit?: string, order: number, allowedMimeTypes?: Array<string> }> } };

export type CreateCheckConfigurationMutationVariables = Exact<{
  command: CreateCheckConfigurationCommand;
}>;


export type CreateCheckConfigurationMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createCheckConfiguration: { __typename?: 'CheckConfiguration', id: string } } };

export type UpdateCheckConfigurationMutationVariables = Exact<{
  command: UpdateCheckConfigurationCommand;
}>;


export type UpdateCheckConfigurationMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', updateCheckConfiguration: { __typename?: 'CheckConfiguration', id: string } } };

export type MoveCheckConfigurationMutationVariables = Exact<{
  stepId: Scalars['ID']['input'];
  command: Move;
}>;


export type MoveCheckConfigurationMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', moveCheckConfiguration: boolean } };

export type DeleteCheckConfigurationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCheckConfigurationMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', deleteCheckConfiguration: string } };

export type ViewCheckConfigurationsDataQueryVariables = Exact<{
  stepId: Scalars['ID']['input'];
}>;


export type ViewCheckConfigurationsDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', checkConfigurations: Array<{ __typename?: 'CheckConfiguration', id: string, type: CheckType, isRequired: boolean, description: string, upperLimit?: number, lowerLimit?: number }> } };

export type CsvEbomLoaderGetCsvColumnNamesQueryVariables = Exact<{
  uploadId: Scalars['ID']['input'];
}>;


export type CsvEbomLoaderGetCsvColumnNamesQuery = { __typename?: 'Query', upload: { __typename?: 'UploadRoot', upload: { __typename?: 'Upload', id: string, extension: { __typename?: 'CsvExtension', columnNames: Array<string> } | { __typename?: 'GenericExtension' } | { __typename?: 'ImageExtension' } | { __typename?: 'ModelExtension' } | { __typename?: 'PdfExtension' } | { __typename?: 'VideoExtension' } } } };

export type CsvEbomLoaderLoadEbomMutationVariables = Exact<{
  command: LoadEbomFromCsvCommand;
}>;


export type CsvEbomLoaderLoadEbomMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', loadEbomFromCsv: { __typename?: 'LoadEbomResult', error?: string, ebom?: { __typename?: 'Ebom', id: string, ebomParts: Array<{ __typename?: 'EbomPart', id: string, articleNumber: string, revision: string, milliQuantity: number, name?: string, articlePath: { __typename?: 'ArticlePath', articleNumbers: Array<string> }, article?: { __typename?: 'Article', id: string } }> } } } };

export type EbomBulkAllocatePartTreeDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EbomBulkAllocatePartTreeDataQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', ebom: { __typename?: 'Ebom', ebomParts: Array<{ __typename?: 'EbomPart', id: string, parentId?: string, articleNumber: string, name?: string, revision: string, unit: ArticleUnit, milliQuantity: number, position?: string, article?: { __typename?: 'Article', id: string }, articlePath: { __typename?: 'ArticlePath', articleNumbers: Array<string> }, stepAllocations: Array<{ __typename?: 'EbomPartAllocation', id: string, milliQuantity: number, article: { __typename?: 'Article', unit: ArticleUnit } }> }> } } };

export type EbomBulkAllocateStepTreeDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EbomBulkAllocateStepTreeDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', bop: { __typename?: 'BOP', nodes: Array<{ __typename?: 'ModuleNode', id: string, parentIds: Array<string>, module: { __typename?: 'Module', id: string, name: string, description?: string, nodes: Array<{ __typename?: 'StepNode', id: string, parentId?: string, step: { __typename?: 'Step', id: string, name: string } }> } }> } } };

export type EbomBulkAllocateStepTreeNodeAllocateMutationVariables = Exact<{
  command: BulkAllocateEbomPartsToStepCommand;
}>;


export type EbomBulkAllocateStepTreeNodeAllocateMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', bulkAllocateEbomPartsToStep: boolean } };

export type EbomDiffDialogDataQueryVariables = Exact<{
  ebomId: Scalars['ID']['input'];
  bopId: Scalars['ID']['input'];
}>;


export type EbomDiffDialogDataQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', ebom: { __typename?: 'Ebom', id: string, name: string }, ebomsForBop: Array<{ __typename?: 'Ebom', id: string, name: string, sourceType: EbomSourceType, sourceId: string }> } };

export type EbomDiffSamePartsMutationVariables = Exact<{
  replacements: Array<ReplaceEbomPartAllocation> | ReplaceEbomPartAllocation;
}>;


export type EbomDiffSamePartsMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', replaceEbomPartAllocations: boolean } };

export type EbomDiffTreeDataQueryVariables = Exact<{
  oldEbomId: Scalars['ID']['input'];
  newEbomId: Scalars['ID']['input'];
}>;


export type EbomDiffTreeDataQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', oldEbom: { __typename?: 'Ebom', id: string, name: string, ebomParts: Array<{ __typename?: 'EbomPart', id: string, articleNumber: string, unit: ArticleUnit, revision: string, name?: string, milliQuantity: number, position?: string, article?: { __typename?: 'Article', id: string }, articlePath: { __typename?: 'ArticlePath', articleNumbers: Array<string> }, stepAllocations: Array<{ __typename?: 'EbomPartAllocation', id: string, milliQuantity: number, article: { __typename?: 'Article', unit: ArticleUnit } }> }> }, newEbom: { __typename?: 'Ebom', id: string, name: string, ebomParts: Array<{ __typename?: 'EbomPart', id: string, articleNumber: string, unit: ArticleUnit, revision: string, name?: string, milliQuantity: number, position?: string, article?: { __typename?: 'Article', id: string }, articlePath: { __typename?: 'ArticlePath', articleNumbers: Array<string> }, stepAllocations: Array<{ __typename?: 'EbomPartAllocation', id: string, milliQuantity: number, article: { __typename?: 'Article', unit: ArticleUnit } }> }> } } };

export type EbomPartDataFragment = { __typename?: 'Ebom', id: string, name: string, ebomParts: Array<{ __typename?: 'EbomPart', id: string, articleNumber: string, unit: ArticleUnit, revision: string, name?: string, milliQuantity: number, position?: string, article?: { __typename?: 'Article', id: string }, articlePath: { __typename?: 'ArticlePath', articleNumbers: Array<string> }, stepAllocations: Array<{ __typename?: 'EbomPartAllocation', id: string, milliQuantity: number, article: { __typename?: 'Article', unit: ArticleUnit } }> }> };

export type EbomDiffViewerDataQueryVariables = Exact<{
  oldEbomId: Scalars['ID']['input'];
  newEbomId: Scalars['ID']['input'];
}>;


export type EbomDiffViewerDataQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', oldEbom: { __typename?: 'Ebom', id: string, name: string, sourceType: EbomSourceType, sourceId: string }, newEbom: { __typename?: 'Ebom', id: string, name: string, sourceType: EbomSourceType, sourceId: string } } };

export type EbomDataFragment = { __typename?: 'Ebom', id: string, name: string, sourceType: EbomSourceType, sourceId: string };

export type EbomModelViewerDataQueryVariables = Exact<{
  ebomId: Scalars['ID']['input'];
}>;


export type EbomModelViewerDataQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', ebom: { __typename?: 'Ebom', id: string, bopUpload?: { __typename?: 'BOPUpload', id: string, glbStatus: GlbStatus, glbUpload?: { __typename?: 'Upload', id: string, url: string } }, ebomParts: Array<{ __typename?: 'EbomPart', id: string, articleNumber: string }> } } };

export type EbomPartAllocationSuggestionsLoaderCreateSuggestionsMutationVariables = Exact<{
  ebomId: Scalars['ID']['input'];
}>;


export type EbomPartAllocationSuggestionsLoaderCreateSuggestionsMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', createEbomPartAllocationSuggestions: Array<{ __typename?: 'EbomPartAllocationSuggestion', source: EbomPartAllocationSuggestionSource }> } };

export type EbomPartDetailsModulesAndStepsQueryVariables = Exact<{
  bopId: Scalars['ID']['input'];
}>;


export type EbomPartDetailsModulesAndStepsQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', bop: { __typename?: 'BOP', nodes: Array<{ __typename?: 'ModuleNode', module: { __typename?: 'Module', id: string, name: string, nodes: Array<{ __typename?: 'StepNode', step: { __typename?: 'Step', id: string, name: string } }> } }> } } };

export type EbomPartDetailsEbomPartQueryVariables = Exact<{
  ebomPartId: Scalars['ID']['input'];
}>;


export type EbomPartDetailsEbomPartQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', ebomPart: { __typename?: 'EbomPart', id: string, ebomId: string, articleNumber: string, revision: string, name?: string, milliQuantity: number, unit: ArticleUnit, snoozeStatus: EbomPartSnoozeStatus, position?: string, article?: { __typename?: 'Article', id: string }, stepAllocations: Array<{ __typename?: 'EbomPartAllocation', milliQuantity: number, step: { __typename?: 'Step', id: string, name: string } }>, stepAllocationSuggestions: Array<{ __typename?: 'EbomPartAllocationSuggestion', id: string, source: EbomPartAllocationSuggestionSource, decision: EbomPartAllocationSuggestionDecision, milliQuantity: number, step: { __typename?: 'Step', id: string, name: string } }> } } };

export type EbomPartDetailsPromoteToArticlesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EbomPartDetailsPromoteToArticlesMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', promoteEbomPartsToArticles: Array<{ __typename?: 'EbomPart', id: string }> } };

export type EbomPartDetailsAllocateEbomPartToStepMutationVariables = Exact<{
  command: AllocateEbomPartToStepCommand;
}>;


export type EbomPartDetailsAllocateEbomPartToStepMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', allocateEbomPartToStep: boolean } };

export type EbomPartDetailsAcceptSuggestionMutationVariables = Exact<{
  command: AcceptEbomPartAllocationSuggestionCommand;
}>;


export type EbomPartDetailsAcceptSuggestionMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', acceptEbomPartAllocationSuggestion: { __typename?: 'EbomPartAllocationSuggestion', decision: EbomPartAllocationSuggestionDecision } } };

export type EbomPartDetailsRejectSuggestionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EbomPartDetailsRejectSuggestionMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', rejectEbomPartAllocationSuggestion: { __typename?: 'EbomPartAllocationSuggestion', decision: EbomPartAllocationSuggestionDecision } } };

export type EbomPartDetailsSnoozesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EbomPartDetailsSnoozesMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', snoozeEbomParts: boolean } };

export type EbomPartDetailsUnsnoozeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EbomPartDetailsUnsnoozeMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', unsnoozeEbomParts: boolean } };

export type EbomPartTreeEbomPartsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EbomPartTreeEbomPartsQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', ebom: { __typename?: 'Ebom', ebomParts: Array<{ __typename?: 'EbomPart', id: string, parentId?: string, articleNumber: string, name?: string, revision: string, milliQuantity: number, unit: ArticleUnit, snoozeStatus: EbomPartSnoozeStatus, position?: string, article?: { __typename?: 'Article', id: string }, articlePath: { __typename?: 'ArticlePath', articleNumbers: Array<string> }, stepAllocations: Array<{ __typename?: 'EbomPartAllocation', milliQuantity: number }>, stepAllocationSuggestions: Array<{ __typename?: 'EbomPartAllocationSuggestion', decision: EbomPartAllocationSuggestionDecision }> }> } } };

export type PromoteEbomPartsEbomQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PromoteEbomPartsEbomQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', ebom: { __typename?: 'Ebom', id: string, ebomParts: Array<{ __typename?: 'EbomPart', id: string, articleNumber: string, revision: string, milliQuantity: number, unit: ArticleUnit, name?: string, articlePath: { __typename?: 'ArticlePath', articleNumbers: Array<string> }, article?: { __typename?: 'Article', id: string } }> } } };

export type PromoteEbomPartsPromotionMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type PromoteEbomPartsPromotionMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', promoteEbomPartsToArticles: Array<{ __typename?: 'EbomPart', id: string, article?: { __typename?: 'Article', id: string, name?: string } }> } };

export type StepEbomLoaderLoadMutationVariables = Exact<{
  command: LoadEbomFromStepFileCommand;
}>;


export type StepEbomLoaderLoadMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', loadEbomFromStepFile: { __typename?: 'LoadEbomResult', error?: string, ebom?: { __typename?: 'Ebom', id: string } } } };

export type BulkAllocationSuggestionActionsDataQueryVariables = Exact<{
  ebomId: Scalars['ID']['input'];
}>;


export type BulkAllocationSuggestionActionsDataQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', ebom: { __typename?: 'Ebom', ebomParts: Array<{ __typename?: 'EbomPart', milliQuantity: number, stepAllocations: Array<{ __typename?: 'EbomPartAllocation', id: string, milliQuantity: number }>, stepAllocationSuggestions: Array<{ __typename?: 'EbomPartAllocationSuggestion', id: string, decision: EbomPartAllocationSuggestionDecision, milliQuantity: number }> }> } } };

export type BulkAllocationSuggestionActionsRejectMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BulkAllocationSuggestionActionsRejectMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', rejectEbomPartAllocationSuggestions: Array<string> } };

export type BulkAllocationSuggestionActionsAcceptMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BulkAllocationSuggestionActionsAcceptMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', acceptEbomPartAllocationSuggestions: Array<string> } };

export type BulkAllocationSuggestionActionsCreateMutationVariables = Exact<{
  ebomId: Scalars['ID']['input'];
}>;


export type BulkAllocationSuggestionActionsCreateMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', createEbomPartAllocationSuggestions: Array<{ __typename?: 'EbomPartAllocationSuggestion', id: string }> } };

export type EbomPartPickerDataQueryVariables = Exact<{
  query: EbomPartSearchQuery;
}>;


export type EbomPartPickerDataQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', ebomParts: Array<{ __typename?: 'EbomPart', id: string, articleNumber: string, revision: string, name?: string, unit: ArticleUnit, milliQuantity: number, articlePath: { __typename?: 'ArticlePath', articleNumbers: Array<string> }, stepAllocations: Array<{ __typename?: 'EbomPartAllocation', id: string, milliQuantity: number }>, article?: { __typename?: 'Article', id: string } }> } };

export type EbomPartPickerPathNamesQueryVariables = Exact<{
  ebomId: Scalars['ID']['input'];
}>;


export type EbomPartPickerPathNamesQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', ebom: { __typename?: 'Ebom', id: string, ebomParts: Array<{ __typename?: 'EbomPart', id: string, articleNumber: string, name?: string }> } } };

export type PartPickerDataQueryVariables = Exact<{
  searchString?: InputMaybe<Scalars['String']['input']>;
}>;


export type PartPickerDataQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', articles: Array<{ __typename?: 'Article', id: string, articleNumber: string, revision: string, name?: string }> } };

export type BopPickerDataQueryVariables = Exact<{
  productConfigurationId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
}>;


export type BopPickerDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', productConfiguration: { __typename?: 'ProductConfiguration', bopsAtSite: Array<{ __typename?: 'BOP', id: string, version: number, versionStatus: VersionStatus }> } } };

export type GetUploadUrlForImageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  maxDimension: Scalars['Int']['input'];
}>;


export type GetUploadUrlForImageQuery = { __typename?: 'Query', upload: { __typename?: 'UploadRoot', upload: { __typename?: 'Upload', id: string, imageUrl: string } } };

export type ModulePickerDataQueryVariables = Exact<{
  bopId: Scalars['ID']['input'];
}>;


export type ModulePickerDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', bop: { __typename?: 'BOP', nodes: Array<{ __typename?: 'ModuleNode', module: { __typename?: 'Module', id: string, name: string, description?: string } }> } } };

export type GetUploadUrlForImagesQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  maxDimension: Scalars['Int']['input'];
}>;


export type GetUploadUrlForImagesQuery = { __typename?: 'Query', upload: { __typename?: 'UploadRoot', uploads: Array<{ __typename?: 'Upload', id: string, imageUrl: string }> } };

export type MultiUploadPickerDataQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MultiUploadPickerDataQuery = { __typename?: 'Query', upload: { __typename?: 'UploadRoot', uploads: Array<{ __typename?: 'Upload', id: string, name: string, contentType: string }> } };

export type OrganizationSlugDataQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  orgId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type OrganizationSlugDataQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', isOrganizationSlugTaken: boolean } };

export type OrganizationUserPickerFindUserQueryVariables = Exact<{
  contains?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganizationUserPickerFindUserQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', organizationSearchUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }> } };

export type OrganizationUserPickerQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type OrganizationUserPickerQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', organizationUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }> } };

export type ProductConfigurationPickerDataQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type ProductConfigurationPickerDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', product: { __typename?: 'Product', productConfigurations: Array<{ __typename?: 'ProductConfiguration', id: string, name: string, archived: boolean }> } } };

export type ProductPickerDataQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductPickerDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', products: Array<{ __typename?: 'Product', id: string, name: string, archived: boolean }> } };

export type SitePickerDataQueryVariables = Exact<{ [key: string]: never; }>;


export type SitePickerDataQuery = { __typename?: 'Query', site: { __typename?: 'SiteRoot', sites: Array<{ __typename?: 'Site', id: string, name: string, archived: boolean }> } };

export type StepOutputPickerDataQueryVariables = Exact<{
  stepId: Scalars['ID']['input'];
}>;


export type StepOutputPickerDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', step: { __typename?: 'Step', outputs: Array<{ __typename?: 'StepOutput', id: string, milliQuantity: number, article: { __typename?: 'Article', id: string, articleNumber: string, name?: string, revision: string, unit: ArticleUnit } }> } } };

export type StepPickerDataQueryVariables = Exact<{
  moduleId: Scalars['ID']['input'];
}>;


export type StepPickerDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', module: { __typename?: 'Module', abbreviation: string, nodes: Array<{ __typename?: 'StepNode', id: string, parentId?: string, step: { __typename?: 'Step', id: string, name: string, durationInSeconds: number, instructionText?: string, stepType: { __typename?: 'StepType', id: string, name: string }, outputs: Array<{ __typename?: 'StepOutput', id: string }> } }> } } };

export type GetStepTypesForPickerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStepTypesForPickerQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', stepTypes: Array<{ __typename?: 'StepType', id: string, name: string, archived: boolean }> } };

export type ToolPickerDataQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type ToolPickerDataQuery = { __typename?: 'Query', site: { __typename?: 'SiteRoot', site: { __typename?: 'Site', tools: Array<{ __typename?: 'Tool', id: string, name: string, description?: string, archived: boolean, imageUploads: Array<{ __typename?: 'Upload', imageUrl: string }> }> } } };

export type IsUserEmailTakenQueryVariables = Exact<{
  email: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type IsUserEmailTakenQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', isEmailTaken: boolean } };

export type CreateIssueDialogMutationVariables = Exact<{
  command: CreateIssue;
}>;


export type CreateIssueDialogMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', createIssue: { __typename?: 'Issue', id: string } } };

export type CreateIssueDialogLinkToStepMutationVariables = Exact<{
  command: LinkIssueToStep;
}>;


export type CreateIssueDialogLinkToStepMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', linkIssueToStep: { __typename?: 'StepIssueLink', id: string } } };

export type CreateIssueDialogLinkToModuleMutationVariables = Exact<{
  command: LinkIssueToModule;
}>;


export type CreateIssueDialogLinkToModuleMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', linkIssueToModule: { __typename?: 'ModuleIssueLink', id: string } } };

export type CreateIssueDialogLinkToBopMutationVariables = Exact<{
  command: LinkIssueToBop;
}>;


export type CreateIssueDialogLinkToBopMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', linkIssueToBOP: { __typename?: 'BOPIssueLink', id: string } } };

export type CreateIssueDialogLinkToSerialNumbersMutationVariables = Exact<{
  command: LinkIssueToSerialNumbers;
}>;


export type CreateIssueDialogLinkToSerialNumbersMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', linkIssueToSerialNumbers: Array<{ __typename?: 'SerialNumberIssueLink', id: string }> } };

export type CreateIssueDialogLinkToArticleMutationVariables = Exact<{
  command: LinkIssueToArticle;
}>;


export type CreateIssueDialogLinkToArticleMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', linkIssueToArticle: { __typename?: 'ArticleIssueLink', id: string } } };

export type CreateIssueLinkDialogBopMutationVariables = Exact<{
  command: LinkIssueToBop;
}>;


export type CreateIssueLinkDialogBopMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', linkIssueToBOP: { __typename?: 'BOPIssueLink', id: string } } };

export type CreateIssueLinkDialogModuleMutationVariables = Exact<{
  command: LinkIssueToModule;
}>;


export type CreateIssueLinkDialogModuleMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', linkIssueToModule: { __typename?: 'ModuleIssueLink', id: string } } };

export type CreateIssueLinkDialogStepMutationVariables = Exact<{
  command: LinkIssueToStep;
}>;


export type CreateIssueLinkDialogStepMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', linkIssueToStep: { __typename?: 'StepIssueLink', id: string } } };

export type CreateIssueLinkDialogSerialNumberMutationVariables = Exact<{
  command: LinkIssueToSerialNumber;
}>;


export type CreateIssueLinkDialogSerialNumberMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', linkIssueToSerialNumber: { __typename?: 'SerialNumberIssueLink', id: string } } };

export type CreateIssueLinkDialogArticleMutationVariables = Exact<{
  command: LinkIssueToArticle;
}>;


export type CreateIssueLinkDialogArticleMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', linkIssueToArticle: { __typename?: 'ArticleIssueLink', id: string } } };

export type IssueCommentListQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IssueCommentListQuery = { __typename?: 'Query', issue: { __typename?: 'IssueRoot', issue: { __typename?: 'Issue', comments: Array<{ __typename?: 'IssueComment', id: string, createdAt: any, uploadIds: Array<string>, description: string, resolvedAt?: any, updatedAt: any, createdByUser: { __typename?: 'User', id: string, firstname: string, lastname: string } }> } } };

export type IssueCommentListCreateMutationVariables = Exact<{
  command: CreateIssueComment;
}>;


export type IssueCommentListCreateMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', createIssueComment: { __typename?: 'IssueComment', id: string } } };

export type IssueCommentListUpdateMutationVariables = Exact<{
  command: UpdateIssueComment;
}>;


export type IssueCommentListUpdateMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', updateIssueComment: { __typename?: 'IssueComment', id: string } } };

export type IssueCommentListDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IssueCommentListDeleteMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', deleteIssueComment: string } };

export type IssueCommentListResolveMutationVariables = Exact<{
  command: SetIssueResolved;
}>;


export type IssueCommentListResolveMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', setIssueCommentResolved: { __typename?: 'IssueComment', id: string } } };

export type IssueDialogDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IssueDialogDataQuery = { __typename?: 'Query', issue: { __typename?: 'IssueRoot', issue: { __typename?: 'Issue', id: string, createdAt: any, description: string, name: string, resolvedAt?: any, updatedAt: any, uploadIds: Array<string>, assignedToUserIds: Array<string>, createdByUser: { __typename?: 'User', id: string, firstname: string, lastname: string }, labels: Array<{ __typename?: 'IssueLabel', id: string, name: string, color: string }> } } };

export type IssueDialogUpdateMutationVariables = Exact<{
  command: UpdateIssue;
}>;


export type IssueDialogUpdateMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', updateIssue: { __typename?: 'Issue', id: string } } };

export type IssueDialogDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IssueDialogDeleteMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', deleteIssue: string } };

export type IssueFiltersLabelsQueryVariables = Exact<{ [key: string]: never; }>;


export type IssueFiltersLabelsQuery = { __typename?: 'Query', issue: { __typename?: 'IssueRoot', orgIssueLabels: Array<{ __typename?: 'IssueLabel', id: string, name: string, color: string }> } };

export type IssueLinkEditListDataQueryVariables = Exact<{
  issueId: Scalars['ID']['input'];
}>;


export type IssueLinkEditListDataQuery = { __typename?: 'Query', issue: { __typename?: 'IssueRoot', issue: { __typename?: 'Issue', id: string, links: Array<{ __typename?: 'ArticleIssueLink', id: string, article: { __typename?: 'Article', id: string, articleNumber: string, revision: string } } | { __typename?: 'BOPIssueLink', id: string, bop: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } } } | { __typename?: 'ModuleIssueLink', id: string, bop: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } }, module: { __typename?: 'Module', id: string, name: string } } | { __typename?: 'SerialNumberIssueLink', id: string, poNumber: string, serialNumber: string, bop: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } }, module: { __typename?: 'Module', id: string, name: string }, step: { __typename?: 'Step', id: string, name: string } } | { __typename?: 'StepIssueLink', id: string, bop: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } }, module: { __typename?: 'Module', id: string, name: string }, step: { __typename?: 'Step', id: string, name: string } }> } } };

export type IssueLinkEditListDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IssueLinkEditListDeleteMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', deleteIssueLink: string } };

export type IssuesPerDayGraphQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  till: Scalars['DateTime']['input'];
}>;


export type IssuesPerDayGraphQuery = { __typename?: 'Query', issue: { __typename?: 'IssueRoot', issuesPerDay: Array<{ __typename?: 'IssuesPerDay', day: any, created: number, resolved: number, open: number }> } };

type IssueLinkDisplayDetails_ArticleIssueLink_Fragment = { __typename?: 'ArticleIssueLink', id: string, article: { __typename?: 'Article', id: string, articleNumber: string, revision: string } };

type IssueLinkDisplayDetails_BopIssueLink_Fragment = { __typename?: 'BOPIssueLink', id: string, bop: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } } };

type IssueLinkDisplayDetails_ModuleIssueLink_Fragment = { __typename?: 'ModuleIssueLink', id: string, bop: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } }, module: { __typename?: 'Module', id: string, name: string } };

type IssueLinkDisplayDetails_SerialNumberIssueLink_Fragment = { __typename?: 'SerialNumberIssueLink', id: string, poNumber: string, serialNumber: string, bop: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } }, module: { __typename?: 'Module', id: string, name: string }, step: { __typename?: 'Step', id: string, name: string } };

type IssueLinkDisplayDetails_StepIssueLink_Fragment = { __typename?: 'StepIssueLink', id: string, bop: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } }, module: { __typename?: 'Module', id: string, name: string }, step: { __typename?: 'Step', id: string, name: string } };

export type IssueLinkDisplayDetailsFragment = IssueLinkDisplayDetails_ArticleIssueLink_Fragment | IssueLinkDisplayDetails_BopIssueLink_Fragment | IssueLinkDisplayDetails_ModuleIssueLink_Fragment | IssueLinkDisplayDetails_SerialNumberIssueLink_Fragment | IssueLinkDisplayDetails_StepIssueLink_Fragment;

export type IssueLinkBopDetailsFragment = { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } };

export type IssueLinkModuleDetailsFragment = { __typename?: 'Module', id: string, name: string };

export type IssueLinkStepDetailsFragment = { __typename?: 'Step', id: string, name: string };

type AssociatedIssueTableIssueLink_ArticleIssueLink_Fragment = { __typename?: 'ArticleIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any, assignedToUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }>, labels: Array<{ __typename?: 'IssueLabel', id: string, name: string, color: string }> } };

type AssociatedIssueTableIssueLink_BopIssueLink_Fragment = { __typename?: 'BOPIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any, assignedToUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }>, labels: Array<{ __typename?: 'IssueLabel', id: string, name: string, color: string }> } };

type AssociatedIssueTableIssueLink_ModuleIssueLink_Fragment = { __typename?: 'ModuleIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any, assignedToUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }>, labels: Array<{ __typename?: 'IssueLabel', id: string, name: string, color: string }> } };

type AssociatedIssueTableIssueLink_SerialNumberIssueLink_Fragment = { __typename?: 'SerialNumberIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any, assignedToUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }>, labels: Array<{ __typename?: 'IssueLabel', id: string, name: string, color: string }> } };

type AssociatedIssueTableIssueLink_StepIssueLink_Fragment = { __typename?: 'StepIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any, assignedToUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }>, labels: Array<{ __typename?: 'IssueLabel', id: string, name: string, color: string }> } };

export type AssociatedIssueTableIssueLinkFragment = AssociatedIssueTableIssueLink_ArticleIssueLink_Fragment | AssociatedIssueTableIssueLink_BopIssueLink_Fragment | AssociatedIssueTableIssueLink_ModuleIssueLink_Fragment | AssociatedIssueTableIssueLink_SerialNumberIssueLink_Fragment | AssociatedIssueTableIssueLink_StepIssueLink_Fragment;

export type AccountMenuDataQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountMenuDataQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', organizations: Array<{ __typename?: 'OrganizationUserPermissions', organization: { __typename?: 'Organization', id: string, slug: string, name: string } }> } };

export type GetOrganizationInfoQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetOrganizationInfoQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', organizationBySlug?: { __typename?: 'Organization', id: string, name: string, slug: string } } };

export type UserInfoDataQueryVariables = Exact<{ [key: string]: never; }>;


export type UserInfoDataQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', me?: { __typename?: 'CurrentUserAndPermissions', userPermissions: Array<PermissionUser>, orgPermissions: Array<PermissionOrganization>, organization?: { __typename?: 'Organization', id: string, name: string, slug: string }, user: { __typename?: 'User', id: string, firstname: string, lastname: string, email: string } } } };

export type DownloadMbomDialogDataQueryVariables = Exact<{
  bopId: Scalars['ID']['input'];
}>;


export type DownloadMbomDialogDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', bop: { __typename?: 'BOP', nodes: Array<{ __typename?: 'ModuleNode', id: string, module: { __typename?: 'Module', id: string, name: string, abbreviation: string, description?: string } }> } } };

export type DuplicateModuleMutationVariables = Exact<{
  command: DuplicateModule;
}>;


export type DuplicateModuleMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', duplicateModule: { __typename?: 'Module', id: string } } };

export type ModuleUpsertDialogDataQueryVariables = Exact<{
  bopId: Scalars['ID']['input'];
}>;


export type ModuleUpsertDialogDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', bop: { __typename?: 'BOP', id: string, nodes: Array<{ __typename?: 'ModuleNode', id: string, module: { __typename?: 'Module', id: string, abbreviation: string } }> } } };

export type OperatorBreadcrumbDataQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
  includeProduct: Scalars['Boolean']['input'];
  configId: Scalars['ID']['input'];
  includeConfig: Scalars['Boolean']['input'];
  bopId: Scalars['ID']['input'];
  includeBop: Scalars['Boolean']['input'];
}>;


export type OperatorBreadcrumbDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', product?: { __typename?: 'Product', id: string, name: string }, productConfiguration?: { __typename?: 'ProductConfiguration', id: string, name: string }, bop?: { __typename?: 'BOP', id: string, version: number, versionStatus: VersionStatus, site: { __typename?: 'Site', id: string, name: string }, nodes: Array<{ __typename?: 'ModuleNode', module: { __typename?: 'Module', id: string, name: string } }> } } };

export type MarkModuleViewedMutationVariables = Exact<{
  bopId: Scalars['ID']['input'];
  moduleId: Scalars['ID']['input'];
}>;


export type MarkModuleViewedMutation = { __typename?: 'Mutation', shopFloor: { __typename?: 'ShopFloorMutationRoot', markModuleViewed: boolean } };

export type StepDiffDataQueryVariables = Exact<{
  bopId: Scalars['ID']['input'];
  moduleId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
}>;


export type StepDiffDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', stepDiff?: { __typename?: 'StepDiff', kind: StepChangeKind, changedFields: Array<StepChangeField>, currentStep: { __typename?: 'Step', id: string }, previousStep?: { __typename?: 'Step', id: string } } } };

export type CurrentProductionBatchDataQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentProductionBatchDataQuery = { __typename?: 'Query', shopFloor: { __typename?: 'ShopFloorRoot', productionBatchesInProgressForCurrentUser: Array<{ __typename?: 'ProductionBatch', id: string, poNumber: string, serialNumbers: Array<string>, completed: boolean, assignedUser?: { __typename?: 'User', id: string }, module: { __typename?: 'Module', id: string }, currentStep?: { __typename?: 'Step', id: string } }> } };

export type CurrentProductionBatchUpdateMutationVariables = Exact<{
  command: UpdateProductionBatchCommand;
}>;


export type CurrentProductionBatchUpdateMutation = { __typename?: 'Mutation', shopFloor: { __typename?: 'ShopFloorMutationRoot', updateProductionBatch: { __typename?: 'ProductionBatch', id: string, poNumber: string, serialNumbers: Array<string>, completed: boolean, assignedUser?: { __typename?: 'User', id: string }, module: { __typename?: 'Module', id: string }, currentStep?: { __typename?: 'Step', id: string } } } };

export type CompleteProductionBranchDataQueryVariables = Exact<{
  moduleId: Scalars['ID']['input'];
}>;


export type CompleteProductionBranchDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', module: { __typename?: 'Module', id: string, abbreviation: string, nodes: Array<{ __typename?: 'StepNode', id: string, parentId?: string, step: { __typename?: 'Step', id: string, name: string, checkConfigurations: Array<{ __typename?: 'CheckConfiguration', id: string, description: string, isRequired: boolean, unreleasedChecks: Array<{ __typename?: 'ConfirmCheck', id: string, poNumber: string, serialNumber: string, reportingUser: { __typename?: 'User', id: string } } | { __typename?: 'FileUploadCheck', id: string, poNumber: string, serialNumber: string, reportingUser: { __typename?: 'User', id: string } } | { __typename?: 'NumericCheck', id: string, poNumber: string, serialNumber: string, reportingUser: { __typename?: 'User', id: string } } | { __typename?: 'StringCheck', id: string, poNumber: string, serialNumber: string, reportingUser: { __typename?: 'User', id: string } }> }> } }> } } };

export type CreateProductionBatchMutationVariables = Exact<{
  command: CreateProductionBatchCommand;
}>;


export type CreateProductionBatchMutation = { __typename?: 'Mutation', shopFloor: { __typename?: 'ShopFloorMutationRoot', createProductionBatch: { __typename?: 'ProductionBatch', id: string } } };

export type UserProductionBatchesDataQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserProductionBatchesDataQuery = { __typename?: 'Query', shopFloor: { __typename?: 'ShopFloorRoot', productionBatchesInProgressForUser: Array<{ __typename?: 'ProductionBatch', id: string, poNumber: string, serialNumbers: Array<string>, assignedUser?: { __typename?: 'User', id: string }, currentStep?: { __typename?: 'Step', id: string, name: string }, bop: { __typename?: 'BOP', id: string, version: number, site: { __typename?: 'Site', id: string, name: string }, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } } }, module: { __typename?: 'Module', id: string, name: string } }> } };

export type UserProductionBatchesTransferMutationVariables = Exact<{
  command: TransferProductionBatchCommand;
}>;


export type UserProductionBatchesTransferMutation = { __typename?: 'Mutation', shopFloor: { __typename?: 'ShopFloorMutationRoot', transferProductionBatch: { __typename?: 'ProductionBatch', id: string } } };

export type UserProductionBatchesDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserProductionBatchesDeleteMutation = { __typename?: 'Mutation', shopFloor: { __typename?: 'ShopFloorMutationRoot', deleteProductionBatch: string } };

export type ViewProductionBatchDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ViewProductionBatchDataQuery = { __typename?: 'Query', shopFloor: { __typename?: 'ShopFloorRoot', productionBatch?: { __typename?: 'ProductionBatch', poNumber: string, serialNumbers: Array<string>, completed: boolean, assignedUser?: { __typename?: 'User', firstname: string, lastname: string }, module: { __typename?: 'Module', id: string, name: string }, bop: { __typename?: 'BOP', id: string, version: number, site: { __typename?: 'Site', id: string, name: string }, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } } } } } };

export type ViewProductionBatchSerialNumberDataQueryVariables = Exact<{
  poNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
}>;


export type ViewProductionBatchSerialNumberDataQuery = { __typename?: 'Query', shopFloor: { __typename?: 'ShopFloorRoot', checks: Array<{ __typename?: 'ConfirmCheck', id: string, createdAt: any, confirmed: boolean, reportingUser: { __typename?: 'User', firstname: string, lastname: string }, configuration: { __typename?: 'CheckConfiguration', description: string, id: string } } | { __typename?: 'FileUploadCheck', id: string, createdAt: any, upload: { __typename?: 'Upload', id: string, name: string }, reportingUser: { __typename?: 'User', firstname: string, lastname: string }, configuration: { __typename?: 'CheckConfiguration', description: string, id: string } } | { __typename?: 'NumericCheck', milliQuantity: number, id: string, createdAt: any, reportingUser: { __typename?: 'User', firstname: string, lastname: string }, configuration: { __typename?: 'CheckConfiguration', description: string, id: string } } | { __typename?: 'StringCheck', text: string, id: string, createdAt: any, reportingUser: { __typename?: 'User', firstname: string, lastname: string }, configuration: { __typename?: 'CheckConfiguration', description: string, id: string } }> }, issue: { __typename?: 'IssueRoot', issues: Array<{ __typename?: 'Issue', id: string, name: string, createdAt: any, createdByUser: { __typename?: 'User', firstname: string, lastname: string } }> } };

export type AddFromLibraryDialogDataQueryVariables = Exact<{
  moduleId: Scalars['ID']['input'];
}>;


export type AddFromLibraryDialogDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', librarySteps: Array<{ __typename?: 'Step', id: string, name: string, instructionText?: string, durationInSeconds: number, usageCount: number, stepType: { __typename?: 'StepType', id: string, name: string } }>, module: { __typename?: 'Module', id: string, nodes: Array<{ __typename?: 'StepNode', id: string, isLibraryReference: boolean, step: { __typename?: 'Step', id: string } }> } } };

export type AddNodeFromLibraryMutationVariables = Exact<{
  command: AddTreeGraphNode;
}>;


export type AddNodeFromLibraryMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', addNodeToModuleGraph: boolean } };

export type CreateStepAndAddNodeToModuleGraphMutationVariables = Exact<{
  step: CreateStep;
  node: AddTreeGraphNode;
}>;


export type CreateStepAndAddNodeToModuleGraphMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', addNodeToModuleGraph: boolean, createStep: { __typename?: 'Step', id: string } } };

export type DuplicateStepMutationVariables = Exact<{
  command: DuplicateStep;
}>;


export type DuplicateStepMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', duplicateStep: { __typename?: 'Step', id: string } } };

export type LibraryStepLockToolsDataQueryVariables = Exact<{
  graphNodeStepId: Scalars['ID']['input'];
}>;


export type LibraryStepLockToolsDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', placementToolIds: Array<string> } };

export type LibraryStepLockSetToolsMutationVariables = Exact<{
  command: SetPlacementTools;
}>;


export type LibraryStepLockSetToolsMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', setPlacementTools: boolean } };

export type LibraryStepLockStepQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LibraryStepLockStepQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', step: { __typename?: 'Step', id: string, name: string } } };

export type RemoveLibraryStepFromModuleMutationVariables = Exact<{
  graphNodeStepId: Scalars['ID']['input'];
}>;


export type RemoveLibraryStepFromModuleMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', removeNodeFromModuleGraph: boolean } };

export type UnlinkLibraryStepMutationVariables = Exact<{
  command: UnlinkLibraryStep;
}>;


export type UnlinkLibraryStepMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', unlinkLibraryStep: { __typename?: 'Step', id: string } } };

export type PromoteStepToModuleDataQueryVariables = Exact<{
  moduleId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
}>;


export type PromoteStepToModuleDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', module: { __typename?: 'Module', id: string, nodes: Array<{ __typename?: 'StepNode', id: string, parentId?: string }> }, step: { __typename?: 'Step', id: string, name: string } } };

export type PromoteStepToModuleMutationVariables = Exact<{
  command: PromoteStepToModule;
}>;


export type PromoteStepToModuleMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', promoteStepToModule: { __typename?: 'Module', id: string } } };

export type StepDropDecisionDataQueryVariables = Exact<{
  movedStepId: Scalars['ID']['input'];
  targetStepId: Scalars['ID']['input'];
}>;


export type StepDropDecisionDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', moved: { __typename?: 'Step', id: string, name: string, durationInSeconds: number, instructionText?: string, warningText?: string, toolIds: Array<string>, stepType: { __typename?: 'StepType', id: string }, icons: Array<{ __typename?: 'Icon', id: string }>, missingIcons: Array<{ __typename?: 'Icon', id: string }>, inputs: Array<{ __typename?: 'StepInput', id: string, milliQuantity: number, output: { __typename?: 'StepOutput', id: string, step: { __typename?: 'Step', id: string } } }>, outputs: Array<{ __typename?: 'StepOutput', id: string }>, articleAllocations: Array<{ __typename: 'EbomPartAllocation', milliQuantity: number, article: { __typename?: 'Article', id: string }, ebomPart: { __typename?: 'EbomPart', id: string } } | { __typename: 'ManualArticleAllocation', milliQuantity: number, article: { __typename?: 'Article', id: string } }> }, target: { __typename?: 'Step', id: string, name: string, durationInSeconds: number, instructionText?: string, warningText?: string, toolIds: Array<string>, stepType: { __typename?: 'StepType', id: string }, icons: Array<{ __typename?: 'Icon', id: string }>, missingIcons: Array<{ __typename?: 'Icon', id: string }>, inputs: Array<{ __typename?: 'StepInput', id: string, milliQuantity: number, output: { __typename?: 'StepOutput', id: string, step: { __typename?: 'Step', id: string } } }>, outputs: Array<{ __typename?: 'StepOutput', id: string }>, articleAllocations: Array<{ __typename: 'EbomPartAllocation', milliQuantity: number, article: { __typename?: 'Article', id: string }, ebomPart: { __typename?: 'EbomPart', id: string } } | { __typename: 'ManualArticleAllocation', milliQuantity: number, article: { __typename?: 'Article', id: string } }> } } };

export type StepDropDecisionStepFragment = { __typename?: 'Step', id: string, name: string, durationInSeconds: number, instructionText?: string, warningText?: string, toolIds: Array<string>, stepType: { __typename?: 'StepType', id: string }, icons: Array<{ __typename?: 'Icon', id: string }>, missingIcons: Array<{ __typename?: 'Icon', id: string }>, inputs: Array<{ __typename?: 'StepInput', id: string, milliQuantity: number, output: { __typename?: 'StepOutput', id: string, step: { __typename?: 'Step', id: string } } }>, outputs: Array<{ __typename?: 'StepOutput', id: string }>, articleAllocations: Array<{ __typename: 'EbomPartAllocation', milliQuantity: number, article: { __typename?: 'Article', id: string }, ebomPart: { __typename?: 'EbomPart', id: string } } | { __typename: 'ManualArticleAllocation', milliQuantity: number, article: { __typename?: 'Article', id: string } }> };

export type StepDropDecisionAllocateArticleMutationVariables = Exact<{
  command: AllocateArticleToStepCommand;
}>;


export type StepDropDecisionAllocateArticleMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', allocateArticleToStep: boolean } };

export type StepDropDecisionAllocateEbomPartMutationVariables = Exact<{
  command: AllocateEbomPartToStepCommand;
}>;


export type StepDropDecisionAllocateEbomPartMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', allocateEbomPartToStep: boolean } };

export type StepDropDecisionUpdateStepMutationVariables = Exact<{
  step: UpdateStep;
}>;


export type StepDropDecisionUpdateStepMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', updateStep: { __typename?: 'Step', id: string } } };

export type StepDropDecisionSetStepIconsMutationVariables = Exact<{
  command: SetStepIcons;
}>;


export type StepDropDecisionSetStepIconsMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', setStepIcons: { __typename?: 'Step', id: string } } };

export type StepDropDecisionCreateInputMutationVariables = Exact<{
  command: CreateStepInput;
}>;


export type StepDropDecisionCreateInputMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createStepInput: { __typename?: 'StepInput', id: string } } };

export type StepDropDecisionDeleteInputMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StepDropDecisionDeleteInputMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', deleteStepInput: string } };

export type StepIconsFieldDataQueryVariables = Exact<{
  stepId: Scalars['ID']['input'];
}>;


export type StepIconsFieldDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', icons: Array<{ __typename?: 'Icon', id: string, name: string, imageUpload?: { __typename?: 'Upload', id: string, imageUrl: string } }>, step: { __typename?: 'Step', id: string, icons: Array<{ __typename?: 'Icon', id: string }>, missingIcons: Array<{ __typename?: 'Icon', id: string, name: string }> } } };

export type StepIconsFieldSetMutationVariables = Exact<{
  command: SetStepIcons;
}>;


export type StepIconsFieldSetMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', setStepIcons: { __typename?: 'Step', id: string } } };

export type StepInputsSectionDataQueryVariables = Exact<{
  stepId: Scalars['ID']['input'];
}>;


export type StepInputsSectionDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', step: { __typename?: 'Step', inputs: Array<{ __typename?: 'StepInput', id: string, milliQuantity: number, output: { __typename?: 'StepOutput', id: string, milliQuantity: number, step: { __typename?: 'Step', id: string, name: string }, module?: { __typename?: 'Module', id: string, name: string }, article: { __typename?: 'Article', id: string, articleNumber: string, revision: string, name?: string, unit: ArticleUnit } } }> } } };

export type StepInputsSectionPlacementDataQueryVariables = Exact<{
  graphNodeStepId: Scalars['ID']['input'];
}>;


export type StepInputsSectionPlacementDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', placementStepInputs: Array<{ __typename?: 'StepInput', id: string, milliQuantity: number, output: { __typename?: 'StepOutput', id: string, milliQuantity: number, step: { __typename?: 'Step', id: string, name: string }, module?: { __typename?: 'Module', id: string, name: string }, article: { __typename?: 'Article', id: string, articleNumber: string, revision: string, name?: string, unit: ArticleUnit } } }> } };

export type CreateStepInputMutationVariables = Exact<{
  command: CreateStepInput;
}>;


export type CreateStepInputMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createStepInput: { __typename?: 'StepInput', id: string } } };

export type UpdateStepInputMutationVariables = Exact<{
  command: UpdateStepInput;
}>;


export type UpdateStepInputMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', updateStepInput: { __typename?: 'StepInput', id: string } } };

export type DeleteStepInputMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteStepInputMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', deleteStepInput: string } };

export type StepOutputsSectionDataQueryVariables = Exact<{
  stepId: Scalars['ID']['input'];
}>;


export type StepOutputsSectionDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', step: { __typename?: 'Step', outputs: Array<{ __typename?: 'StepOutput', id: string, milliQuantity: number, article: { __typename?: 'Article', id: string, name?: string, articleNumber: string, revision: string, unit: ArticleUnit } }> } } };

export type StepOutputsSectionPlacementDataQueryVariables = Exact<{
  graphNodeStepId: Scalars['ID']['input'];
}>;


export type StepOutputsSectionPlacementDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', placementStepOutputs: Array<{ __typename?: 'StepOutput', id: string, milliQuantity: number, article: { __typename?: 'Article', id: string, name?: string, articleNumber: string, revision: string, unit: ArticleUnit } }> } };

export type CreateStepOutputMutationVariables = Exact<{
  command: CreateStepOutput;
}>;


export type CreateStepOutputMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createStepOutput: { __typename?: 'StepOutput', id: string } } };

export type StepOutputsSectionAssignInputMutationVariables = Exact<{
  command: CreateStepInput;
}>;


export type StepOutputsSectionAssignInputMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createStepInput: { __typename?: 'StepInput', id: string } } };

export type UpdateStepOutputMutationVariables = Exact<{
  command: UpdateStepOutput;
}>;


export type UpdateStepOutputMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', updateStepOutput: { __typename?: 'StepOutput', id: string } } };

export type DeleteStepOutputMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteStepOutputMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', deleteStepOutput: string } };

export type StepPreviewStepTreeQueryVariables = Exact<{
  moduleId: Scalars['ID']['input'];
}>;


export type StepPreviewStepTreeQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', module: { __typename?: 'Module', id: string, abbreviation: string, nodes: Array<{ __typename?: 'StepNode', id: string, parentId?: string, step: { __typename?: 'Step', id: string, name: string, durationInSeconds: number, stepType: { __typename?: 'StepType', id: string, name: string } } }> } } };

export type StepPreviewStepTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type StepPreviewStepTypesQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', stepTypes: Array<{ __typename?: 'StepType', id: string, name: string }> } };

export type StepProposalConverterStepMutationVariables = Exact<{
  command: CreateStep;
  node: AddTreeGraphNode;
}>;


export type StepProposalConverterStepMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', addNodeToModuleGraph: boolean, createStep: { __typename?: 'Step', id: string } } };

export type StepProposalConverterVideosMutationVariables = Exact<{
  commands: Array<CreateVideoStepUpload> | CreateVideoStepUpload;
}>;


export type StepProposalConverterVideosMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createVideoStepUploads: Array<{ __typename?: 'VideoStepUpload', id: string }> } };

export type StepProposalConverterImageMutationVariables = Exact<{
  command: CreateImageStepUpload;
}>;


export type StepProposalConverterImageMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createImageStepUpload: { __typename?: 'ImageStepUpload', id: string } } };

export type StepProposalConverterSnapshotMutationVariables = Exact<{
  command: CreateSnapshotUpload;
}>;


export type StepProposalConverterSnapshotMutation = { __typename?: 'Mutation', upload: { __typename?: 'UploadMutationRoot', createSnapshotUpload: { __typename?: 'Upload', id: string, url: string } } };

export type StepProposalConverterCheckMutationVariables = Exact<{
  command: CreateCheckConfigurationCommand;
}>;


export type StepProposalConverterCheckMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createCheckConfiguration: { __typename?: 'CheckConfiguration', id: string } } };

export type StepProposalsFromDocxMutationVariables = Exact<{
  command: CreateStepProposalsFromDocx;
}>;


export type StepProposalsFromDocxMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createStepProposalsFromDOCX: { __typename?: 'StepProposalResult', errors: Array<string>, proposals: Array<{ __typename?: 'StepProposal', id: string, name: string, instructionText?: string, durationInSeconds: number, uploadProposals: Array<{ __typename?: 'StepUploadProposal', id: string, fragmentStartInMillis?: number, fragmentEndInMillis?: number, upload: { __typename?: 'Upload', id: string, url: string, extension: { __typename?: 'CsvExtension' } | { __typename?: 'GenericExtension' } | { __typename?: 'ImageExtension' } | { __typename?: 'ModelExtension' } | { __typename?: 'PdfExtension' } | { __typename?: 'VideoExtension', url: string } } }>, checkProposals: Array<{ __typename?: 'CheckProposal', id: string, type: CheckType, description: string, upperLimit?: number, lowerLimit?: number, isRequired: boolean }> }> } } };

export type StepProposalsFromMediaMimeTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type StepProposalsFromMediaMimeTypesQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', createStepProposalsFromMediaSupportedMimeTypes: Array<string> } };

export type StepProposalsFromMediaMutationVariables = Exact<{
  command: CreateStepProposalsFromMedia;
}>;


export type StepProposalsFromMediaMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createStepProposalsFromMedia: { __typename?: 'StepProposalResult', errors: Array<string>, proposals: Array<{ __typename?: 'StepProposal', id: string, name: string, instructionText?: string, durationInSeconds: number, uploadProposals: Array<{ __typename?: 'StepUploadProposal', id: string, fragmentStartInMillis?: number, fragmentEndInMillis?: number, upload: { __typename?: 'Upload', id: string, url: string, extension: { __typename?: 'CsvExtension' } | { __typename?: 'GenericExtension' } | { __typename?: 'ImageExtension' } | { __typename?: 'ModelExtension' } | { __typename?: 'PdfExtension' } | { __typename?: 'VideoExtension', url: string } } }>, checkProposals: Array<{ __typename?: 'CheckProposal', id: string, type: CheckType, description: string, upperLimit?: number, lowerLimit?: number, isRequired: boolean }> }> } } };

export type StepProposalsFromPdfAnalysisQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StepProposalsFromPdfAnalysisQuery = { __typename?: 'Query', upload: { __typename?: 'UploadRoot', upload: { __typename?: 'Upload', extension: { __typename?: 'CsvExtension' } | { __typename?: 'GenericExtension' } | { __typename?: 'ImageExtension' } | { __typename?: 'ModelExtension' } | { __typename?: 'PdfExtension', analysis: { __typename?: 'PdfExtensionAnalysis', numberOfPages: number, numberOfImages: number } } | { __typename?: 'VideoExtension' } } } };

export type StepProposalsFromPdfMutationVariables = Exact<{
  command: CreateStepProposalsFromPdf;
}>;


export type StepProposalsFromPdfMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createStepProposalsFromPDF: { __typename?: 'StepProposalResult', errors: Array<string>, proposals: Array<{ __typename?: 'StepProposal', id: string, name: string, instructionText?: string, durationInSeconds: number, uploadProposals: Array<{ __typename?: 'StepUploadProposal', id: string, fragmentStartInMillis?: number, fragmentEndInMillis?: number, upload: { __typename?: 'Upload', id: string, url: string, extension: { __typename?: 'CsvExtension' } | { __typename?: 'GenericExtension' } | { __typename?: 'ImageExtension' } | { __typename?: 'ModelExtension' } | { __typename?: 'PdfExtension' } | { __typename?: 'VideoExtension', url: string } } }>, checkProposals: Array<{ __typename?: 'CheckProposal', id: string, type: CheckType, description: string, upperLimit?: number, lowerLimit?: number, isRequired: boolean }> }> } } };

export type StepToolbarDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StepToolbarDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', step: { __typename?: 'Step', id: string, name: string } } };

export type DeleteStepMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteStepMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', deleteStep?: string } };

export type StepTreeDataQueryVariables = Exact<{
  bopId: Scalars['ID']['input'];
  moduleId: Scalars['ID']['input'];
  includeIssues: Scalars['Boolean']['input'];
}>;


export type StepTreeDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', bop: { __typename?: 'BOP', id: string, versionStatus: VersionStatus, productConfiguration: { __typename?: 'ProductConfiguration', id: string, archived: boolean } }, module: { __typename?: 'Module', id: string, abbreviation: string, nodes: Array<{ __typename?: 'StepNode', id: string, parentId?: string, isLibraryReference: boolean, step: { __typename?: 'Step', id: string, name: string, durationInSeconds: number, stepType: { __typename?: 'StepType', id: string, name: string }, icons: Array<{ __typename?: 'Icon', id: string, name: string, imageUpload?: { __typename?: 'Upload', id: string, imageUrl: string } }>, issueLinks?: Array<{ __typename?: 'ArticleIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any, assignedToUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }>, labels: Array<{ __typename?: 'IssueLabel', id: string, name: string, color: string }> } } | { __typename?: 'BOPIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any, assignedToUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }>, labels: Array<{ __typename?: 'IssueLabel', id: string, name: string, color: string }> } } | { __typename?: 'ModuleIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any, assignedToUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }>, labels: Array<{ __typename?: 'IssueLabel', id: string, name: string, color: string }> } } | { __typename?: 'SerialNumberIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any, assignedToUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }>, labels: Array<{ __typename?: 'IssueLabel', id: string, name: string, color: string }> } } | { __typename?: 'StepIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any, assignedToUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }>, labels: Array<{ __typename?: 'IssueLabel', id: string, name: string, color: string }> } }> } }> } } };

export type SetGraphForModuleMutationVariables = Exact<{
  graph: SetTreeGraph;
}>;


export type SetGraphForModuleMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', setModuleGraph: boolean } };

export type UpdateStepDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  includeIssues: Scalars['Boolean']['input'];
}>;


export type UpdateStepDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', step: { __typename?: 'Step', id: string, durationInSeconds: number, instructionText?: string, warningText?: string, name: string, toolIds: Array<string>, stepType: { __typename?: 'StepType', id: string, name: string }, tools: Array<{ __typename?: 'Tool', id: string, name: string, imageUploads: Array<{ __typename?: 'Upload', id: string, imageUrl: string }> }>, issueLinks?: Array<{ __typename?: 'ArticleIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any, assignedToUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }>, labels: Array<{ __typename?: 'IssueLabel', id: string, name: string, color: string }> } } | { __typename?: 'BOPIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any, assignedToUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }>, labels: Array<{ __typename?: 'IssueLabel', id: string, name: string, color: string }> } } | { __typename?: 'ModuleIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any, assignedToUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }>, labels: Array<{ __typename?: 'IssueLabel', id: string, name: string, color: string }> } } | { __typename?: 'SerialNumberIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any, assignedToUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }>, labels: Array<{ __typename?: 'IssueLabel', id: string, name: string, color: string }> } } | { __typename?: 'StepIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any, assignedToUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }>, labels: Array<{ __typename?: 'IssueLabel', id: string, name: string, color: string }> } }> } } };

export type UpdateStepMutationVariables = Exact<{
  step: UpdateStep;
}>;


export type UpdateStepMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', updateStep: { __typename?: 'Step', id: string } } };

export type ViewStepDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  imageOptions: ImageOptions;
}>;


export type ViewStepDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', step: { __typename?: 'Step', id: string, instructionText?: string, warningText?: string, name: string, toolIds: Array<string>, stepType: { __typename?: 'StepType', id: string, name: string }, module?: { __typename?: 'Module', id: string }, issueLinks: Array<{ __typename?: 'ArticleIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any, assignedToUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }>, labels: Array<{ __typename?: 'IssueLabel', id: string, name: string, color: string }> } } | { __typename?: 'BOPIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any, assignedToUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }>, labels: Array<{ __typename?: 'IssueLabel', id: string, name: string, color: string }> } } | { __typename?: 'ModuleIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any, assignedToUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }>, labels: Array<{ __typename?: 'IssueLabel', id: string, name: string, color: string }> } } | { __typename?: 'SerialNumberIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any, assignedToUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }>, labels: Array<{ __typename?: 'IssueLabel', id: string, name: string, color: string }> } } | { __typename?: 'StepIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any, assignedToUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }>, labels: Array<{ __typename?: 'IssueLabel', id: string, name: string, color: string }> } }>, icons: Array<{ __typename?: 'Icon', id: string, name: string, imageUpload?: { __typename?: 'Upload', id: string, imageUrl: string } }>, tools: Array<{ __typename?: 'Tool', id: string, name: string, description?: string, imageUploads: Array<{ __typename?: 'Upload', id: string, imageUrl: string }> }>, articleAllocations: Array<{ __typename?: 'EbomPartAllocation', id: string, milliQuantity: number, article: { __typename?: 'Article', id: string, type: ArticleType, name?: string, unit: ArticleUnit, revision: string, articleNumber: string } } | { __typename?: 'ManualArticleAllocation', id: string, milliQuantity: number, article: { __typename?: 'Article', id: string, type: ArticleType, name?: string, unit: ArticleUnit, revision: string, articleNumber: string } }>, uploads: Array<{ __typename?: 'ImageStepUpload', id: string } | { __typename?: 'VideoStepUpload', id: string }>, inputs: Array<{ __typename?: 'StepInput', id: string, milliQuantity: number, output: { __typename?: 'StepOutput', id: string, milliQuantity: number, module?: { __typename?: 'Module', id: string, name: string }, step: { __typename?: 'Step', id: string, name: string }, article: { __typename?: 'Article', id: string, name?: string, articleNumber: string, revision: string, unit: ArticleUnit } } }> } } };

export type ViewStepPlacementDataQueryVariables = Exact<{
  graphNodeStepId: Scalars['ID']['input'];
  imageOptions: ImageOptions;
}>;


export type ViewStepPlacementDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', placementArticleAllocations: Array<{ __typename?: 'EbomPartAllocation', id: string, milliQuantity: number, article: { __typename?: 'Article', id: string, type: ArticleType, name?: string, unit: ArticleUnit, revision: string, articleNumber: string } } | { __typename?: 'ManualArticleAllocation', id: string, milliQuantity: number, article: { __typename?: 'Article', id: string, type: ArticleType, name?: string, unit: ArticleUnit, revision: string, articleNumber: string } }>, placementStepInputs: Array<{ __typename?: 'StepInput', id: string, milliQuantity: number, output: { __typename?: 'StepOutput', id: string, milliQuantity: number, module?: { __typename?: 'Module', id: string, name: string }, step: { __typename?: 'Step', id: string, name: string }, article: { __typename?: 'Article', id: string, name?: string, articleNumber: string, revision: string, unit: ArticleUnit } } }>, placementTools: Array<{ __typename?: 'Tool', id: string, name: string, description?: string, imageUploads: Array<{ __typename?: 'Upload', id: string, imageUrl: string }> }> } };

export type WhereUsedPanelDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WhereUsedPanelDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', step: { __typename?: 'Step', id: string, usages: Array<{ __typename?: 'StepUsage', bop: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } }, module: { __typename?: 'Module', id: string, name: string }, step: { __typename?: 'Step', id: string, name: string } }> } } };

export type StepProposalResultDetailsFragment = { __typename?: 'StepProposalResult', errors: Array<string>, proposals: Array<{ __typename?: 'StepProposal', id: string, name: string, instructionText?: string, durationInSeconds: number, uploadProposals: Array<{ __typename?: 'StepUploadProposal', id: string, fragmentStartInMillis?: number, fragmentEndInMillis?: number, upload: { __typename?: 'Upload', id: string, url: string, extension: { __typename?: 'CsvExtension' } | { __typename?: 'GenericExtension' } | { __typename?: 'ImageExtension' } | { __typename?: 'ModelExtension' } | { __typename?: 'PdfExtension' } | { __typename?: 'VideoExtension', url: string } } }>, checkProposals: Array<{ __typename?: 'CheckProposal', id: string, type: CheckType, description: string, upperLimit?: number, lowerLimit?: number, isRequired: boolean }> }> };

export type CreateImageStepUploadMutationVariables = Exact<{
  command: CreateImageStepUpload;
}>;


export type CreateImageStepUploadMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createImageStepUpload: { __typename?: 'ImageStepUpload', id: string } } };

export type SaveImageStepUploadEditMutationVariables = Exact<{
  command: SaveImageStepUploadEdit;
}>;


export type SaveImageStepUploadEditMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', saveImageStepUploadEdit: { __typename?: 'ImageStepUpload', id: string } } };

export type CreateVideoStepUploadMutationVariables = Exact<{
  command: CreateVideoStepUpload;
}>;


export type CreateVideoStepUploadMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createVideoStepUpload: { __typename?: 'VideoStepUpload', id: string } } };

export type FormImageStepUploadDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  options: ImageOptions;
}>;


export type FormImageStepUploadDataQuery = { __typename?: 'Query', upload: { __typename?: 'UploadRoot', upload: { __typename?: 'Upload', extension: { __typename?: 'CsvExtension' } | { __typename?: 'GenericExtension' } | { __typename?: 'ImageExtension', url: string } | { __typename?: 'ModelExtension' } | { __typename?: 'PdfExtension' } | { __typename?: 'VideoExtension' } } } };

export type FormVideoStepUploadDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FormVideoStepUploadDataQuery = { __typename?: 'Query', upload: { __typename?: 'UploadRoot', upload: { __typename?: 'Upload', extension: { __typename?: 'CsvExtension' } | { __typename?: 'GenericExtension' } | { __typename?: 'ImageExtension' } | { __typename?: 'ModelExtension' } | { __typename?: 'PdfExtension' } | { __typename?: 'VideoExtension', url: string } } } };

export type CreateSnapshotStepUploadMutationVariables = Exact<{
  command: CreateSnapshotStepUpload;
}>;


export type CreateSnapshotStepUploadMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createSnapshotStepUpload: { __typename?: 'ImageStepUpload', id: string, upload: { __typename?: 'Upload', id: string } } } };

export type UpdateSnapshotCaptionMutationVariables = Exact<{
  command: UpdateImageStepUpload;
}>;


export type UpdateSnapshotCaptionMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', updateImageStepUpload: { __typename?: 'ImageStepUpload', id: string } } };

export type ImageEditorDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  options: ImageOptions;
}>;


export type ImageEditorDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', imageStepUpload: { __typename?: 'ImageStepUpload', id: string, editLayer?: string, originalUpload?: { __typename?: 'Upload', id: string, name: string, contentType: string, extension: { __typename?: 'CsvExtension' } | { __typename?: 'GenericExtension' } | { __typename?: 'ImageExtension', url: string } | { __typename?: 'ModelExtension' } | { __typename?: 'PdfExtension' } | { __typename?: 'VideoExtension' } }, upload: { __typename?: 'Upload', id: string, name: string, contentType: string, extension: { __typename?: 'CsvExtension' } | { __typename?: 'GenericExtension' } | { __typename?: 'ImageExtension', url: string } | { __typename?: 'ModelExtension' } | { __typename?: 'PdfExtension' } | { __typename?: 'VideoExtension' } } } } };

export type ImageEditorDraftDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  options: ImageOptions;
}>;


export type ImageEditorDraftDataQuery = { __typename?: 'Query', upload: { __typename?: 'UploadRoot', upload: { __typename?: 'Upload', id: string, name: string, contentType: string, extension: { __typename?: 'CsvExtension' } | { __typename?: 'GenericExtension' } | { __typename?: 'ImageExtension', url: string } | { __typename?: 'ModelExtension' } | { __typename?: 'PdfExtension' } | { __typename?: 'VideoExtension' } } } };

export type ClearImageStepUploadEditMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ClearImageStepUploadEditMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', clearImageStepUploadEdit: { __typename?: 'ImageStepUpload', id: string } } };

export type StepUploadListDataQueryVariables = Exact<{
  stepId: Scalars['ID']['input'];
  imageOptions: ImageOptions;
}>;


export type StepUploadListDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', step: { __typename?: 'Step', uploads: Array<{ __typename?: 'ImageStepUpload', id: string, upload: { __typename?: 'Upload', name: string, contentType: string, extension: { __typename: 'CsvExtension' } | { __typename: 'GenericExtension' } | { __typename: 'ImageExtension', url: string } | { __typename: 'ModelExtension' } | { __typename: 'PdfExtension' } | { __typename: 'VideoExtension', url: string } } } | { __typename?: 'VideoStepUpload', id: string, fragmentStartInMillis?: number, upload: { __typename?: 'Upload', name: string, contentType: string, extension: { __typename: 'CsvExtension' } | { __typename: 'GenericExtension' } | { __typename: 'ImageExtension', url: string } | { __typename: 'ModelExtension' } | { __typename: 'PdfExtension' } | { __typename: 'VideoExtension', url: string } } }> } } };

export type StepUploadListDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StepUploadListDeleteMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', deleteStepUpload: string } };

export type StepUploadListMoveMutationVariables = Exact<{
  stepId: Scalars['ID']['input'];
  command: Move;
}>;


export type StepUploadListMoveMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', moveStepUpload: boolean } };

export type StepUploadViewerDataQueryVariables = Exact<{
  stepId: Scalars['ID']['input'];
  imageOptions: ImageOptions;
}>;


export type StepUploadViewerDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', step: { __typename?: 'Step', uploads: Array<{ __typename?: 'ImageStepUpload', id: string, caption?: string, upload: { __typename?: 'Upload', id: string, extension: { __typename?: 'CsvExtension' } | { __typename?: 'GenericExtension' } | { __typename?: 'ImageExtension', url: string } | { __typename?: 'ModelExtension' } | { __typename?: 'PdfExtension' } | { __typename?: 'VideoExtension', url: string } } } | { __typename?: 'VideoStepUpload', id: string, caption?: string, fragmentStartInMillis?: number, fragmentEndInMillis?: number, fragmentLoop?: boolean, upload: { __typename?: 'Upload', id: string, extension: { __typename?: 'CsvExtension' } | { __typename?: 'GenericExtension' } | { __typename?: 'ImageExtension', url: string } | { __typename?: 'ModelExtension' } | { __typename?: 'PdfExtension' } | { __typename?: 'VideoExtension', url: string } }, trimmedUpload?: { __typename?: 'Upload', id: string, extension: { __typename?: 'CsvExtension' } | { __typename?: 'GenericExtension' } | { __typename?: 'ImageExtension' } | { __typename?: 'ModelExtension' } | { __typename?: 'PdfExtension' } | { __typename?: 'VideoExtension', url: string } } }> } } };

export type UpdateImageStepUploadDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UpdateImageStepUploadDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', imageStepUpload: { __typename?: 'ImageStepUpload', id: string, caption?: string, upload: { __typename?: 'Upload', id: string } } } };

export type UpdateImageStepUploadMutationVariables = Exact<{
  command: UpdateImageStepUpload;
}>;


export type UpdateImageStepUploadMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', updateImageStepUpload: { __typename?: 'ImageStepUpload', id: string } } };

export type UpdateVideoStepUploadDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UpdateVideoStepUploadDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', videoStepUpload: { __typename?: 'VideoStepUpload', id: string, caption?: string, fragmentStartInMillis?: number, fragmentEndInMillis?: number, fragmentLoop?: boolean, upload: { __typename?: 'Upload', id: string } } } };

export type UpdateVideoStepUploadMutationVariables = Exact<{
  command: UpdateVideoStepUpload;
}>;


export type UpdateVideoStepUploadMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', updateVideoStepUpload: { __typename?: 'VideoStepUpload', id: string } } };

export type ImagesViewerDataQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
}>;


export type ImagesViewerDataQuery = { __typename?: 'Query', upload: { __typename?: 'UploadRoot', uploads: Array<{ __typename?: 'Upload', id: string, name: string, imageUrl: string }> } };

export type UploadListDataQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UploadListDataQuery = { __typename?: 'Query', upload: { __typename?: 'UploadRoot', uploads: Array<{ __typename?: 'Upload', id: string, createdAt: any, name: string, contentType: string }> } };

export type UploadListUrlQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UploadListUrlQuery = { __typename?: 'Query', upload: { __typename?: 'UploadRoot', upload: { __typename?: 'Upload', id: string, url: string, name: string } } };

export type UploadPickerDataQueryVariables = Exact<{
  query: UploadQuery;
  imageOptions: ImageOptions;
}>;


export type UploadPickerDataQuery = { __typename?: 'Query', upload: { __typename?: 'UploadRoot', search: Array<{ __typename?: 'Upload', id: string, contentType: string, name: string, createdAt: any, extension: { __typename?: 'CsvExtension' } | { __typename?: 'GenericExtension' } | { __typename?: 'ImageExtension', url: string } | { __typename?: 'ModelExtension' } | { __typename?: 'PdfExtension' } | { __typename?: 'VideoExtension', url: string } }> } };

export type UploadPickerSelectedUploadsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UploadPickerSelectedUploadsQuery = { __typename?: 'Query', upload: { __typename?: 'UploadRoot', uploads: Array<{ __typename?: 'Upload', id: string, contentType: string, name: string }> } };

type UploadUsageLocationDisplayDetails_BopUploadUsageLocation_Fragment = { __typename: 'BOPUploadUsageLocation', bop?: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } } };

type UploadUsageLocationDisplayDetails_CheckUploadUsageLocation_Fragment = { __typename: 'CheckUploadUsageLocation', step: { __typename?: 'Step', id: string, name: string }, module?: { __typename?: 'Module', id: string, name: string }, bop?: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } } };

type UploadUsageLocationDisplayDetails_IconUploadUsageLocation_Fragment = { __typename: 'IconUploadUsageLocation', icon?: { __typename?: 'Icon', id: string, name: string } };

type UploadUsageLocationDisplayDetails_IssueCommentUploadUsageLocation_Fragment = { __typename: 'IssueCommentUploadUsageLocation', comment: { __typename?: 'IssueComment', id: string }, issue: { __typename?: 'Issue', id: string, name: string } };

type UploadUsageLocationDisplayDetails_IssueUploadUsageLocation_Fragment = { __typename: 'IssueUploadUsageLocation', issue: { __typename?: 'Issue', id: string, name: string } };

type UploadUsageLocationDisplayDetails_ProductConfigurationUploadUsageLocation_Fragment = { __typename: 'ProductConfigurationUploadUsageLocation', productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } } };

type UploadUsageLocationDisplayDetails_ProductUploadUsageLocation_Fragment = { __typename: 'ProductUploadUsageLocation', product: { __typename?: 'Product', id: string, name: string } };

type UploadUsageLocationDisplayDetails_StepImageUploadUsageLocation_Fragment = { __typename: 'StepImageUploadUsageLocation', step: { __typename?: 'Step', id: string, name: string }, module?: { __typename?: 'Module', id: string, name: string }, bop?: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } } };

type UploadUsageLocationDisplayDetails_StepUploadUsageLocation_Fragment = { __typename: 'StepUploadUsageLocation', step: { __typename?: 'Step', id: string, name: string }, module?: { __typename?: 'Module', id: string, name: string }, bop?: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } } };

type UploadUsageLocationDisplayDetails_ToolImageUploadUsageLocation_Fragment = { __typename: 'ToolImageUploadUsageLocation', tool: { __typename?: 'Tool', id: string, name: string }, site?: { __typename?: 'Site', id: string, name: string } };

export type UploadUsageLocationDisplayDetailsFragment = UploadUsageLocationDisplayDetails_BopUploadUsageLocation_Fragment | UploadUsageLocationDisplayDetails_CheckUploadUsageLocation_Fragment | UploadUsageLocationDisplayDetails_IconUploadUsageLocation_Fragment | UploadUsageLocationDisplayDetails_IssueCommentUploadUsageLocation_Fragment | UploadUsageLocationDisplayDetails_IssueUploadUsageLocation_Fragment | UploadUsageLocationDisplayDetails_ProductConfigurationUploadUsageLocation_Fragment | UploadUsageLocationDisplayDetails_ProductUploadUsageLocation_Fragment | UploadUsageLocationDisplayDetails_StepImageUploadUsageLocation_Fragment | UploadUsageLocationDisplayDetails_StepUploadUsageLocation_Fragment | UploadUsageLocationDisplayDetails_ToolImageUploadUsageLocation_Fragment;

export type UploadUsageLocationBopDetailsFragment = { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } };

export type AgreeToTermsDataQueryVariables = Exact<{ [key: string]: never; }>;


export type AgreeToTermsDataQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', hasAgreedToTerms: boolean } };

export type AgreeToTermsAgreementMutationVariables = Exact<{
  logEntry: Scalars['String']['input'];
}>;


export type AgreeToTermsAgreementMutation = { __typename?: 'Mutation', account: { __typename?: 'AccountMutationRoot', agreeToTerms: boolean } };

export type OrganizationUserListDataQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type OrganizationUserListDataQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', organizationUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }> } };

export type UserOrganizationPermissionsDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserOrganizationPermissionsDataQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', organizationPermissions: Array<PermissionOrganization>, organizationUser: { __typename?: 'User', id: string, firstname: string, lastname: string } } };

export type UserOrganizationPermissionsSetMutationVariables = Exact<{
  command: SetOrganizationPermissions;
}>;


export type UserOrganizationPermissionsSetMutation = { __typename?: 'Mutation', account: { __typename?: 'AccountMutationRoot', setOrganizationPermissions: Array<PermissionOrganization> } };

export type UserPlatformPermissionsDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserPlatformPermissionsDataQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', adminUserPermissions: Array<PermissionUser>, adminOrganizations: Array<{ __typename?: 'Organization', id: string, name: string }>, adminUser: { __typename?: 'User', firstname: string, lastname: string }, adminOrganizationPermissions: Array<{ __typename?: 'OrganizationUserPermissions', permissions: Array<PermissionOrganization>, organization: { __typename?: 'Organization', id: string, name: string } }> } };

export type AdminSetUserPermissionsMutationVariables = Exact<{
  command: SetUserPermissions;
}>;


export type AdminSetUserPermissionsMutation = { __typename?: 'Mutation', account: { __typename?: 'AccountMutationRoot', adminSetUserPermissions: Array<PermissionUser> } };

export type AdminSetOrgPermissionsMutationVariables = Exact<{
  command: SetOrganizationPermissions;
}>;


export type AdminSetOrgPermissionsMutation = { __typename?: 'Mutation', account: { __typename?: 'AccountMutationRoot', adminSetOrganizationPermissions: Array<PermissionOrganization> } };

export type DeleteOrgUserPermissionsMutationVariables = Exact<{
  command: DeleteOrganizationPermissions;
}>;


export type DeleteOrgUserPermissionsMutation = { __typename?: 'Mutation', account: { __typename?: 'AccountMutationRoot', adminDeleteOrganizationPermissions: boolean } };

export type UseAuthorizationDataQueryVariables = Exact<{ [key: string]: never; }>;


export type UseAuthorizationDataQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', orgPermissionsHierarchy: Array<{ __typename?: 'OrgReachablePermission', permission: PermissionOrganization, reachable: Array<PermissionOrganization> }>, me?: { __typename?: 'CurrentUserAndPermissions', userPermissions: Array<PermissionUser>, orgPermissions: Array<PermissionOrganization> } } };

export type CreateStepWithModuleGraphNodeMutationVariables = Exact<{
  step: CreateStep;
  node: AddTreeGraphNode;
}>;


export type CreateStepWithModuleGraphNodeMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', addNodeToModuleGraph: boolean, createStep: { __typename?: 'Step', id: string } } };

export type Cross3dModelCheckQueryVariables = Exact<{
  stepId: Scalars['ID']['input'];
  bopId: Scalars['ID']['input'];
}>;


export type Cross3dModelCheckQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', step: { __typename?: 'Step', id: string, articleAllocations: Array<{ __typename: 'EbomPartAllocation', ebomPart: { __typename?: 'EbomPart', ebomId: string } } | { __typename: 'ManualArticleAllocation' }> } }, article: { __typename?: 'ArticleRoot', ebomsForBop: Array<{ __typename?: 'Ebom', id: string, name: string, bopUpload?: { __typename?: 'BOPUpload', id: string } }> } };

export type IssueDialogOrgLabelsQueryVariables = Exact<{ [key: string]: never; }>;


export type IssueDialogOrgLabelsQuery = { __typename?: 'Query', issue: { __typename?: 'IssueRoot', orgIssueLabels: Array<{ __typename?: 'IssueLabel', id: string, name: string, color: string }> } };

export type IssueDialogSetIssueLabelsMutationVariables = Exact<{
  issueId: Scalars['ID']['input'];
  labelIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type IssueDialogSetIssueLabelsMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', setIssueLabels: Array<{ __typename?: 'IssueLabel', id: string }> } };

export type SetStepPreferred3dModelMutationVariables = Exact<{
  command: SetStepPreferred3dModel;
}>;


export type SetStepPreferred3dModelMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', setStepPreferred3dModel: { __typename?: 'Step', id: string } } };

export type StepArticleColorsQueryVariables = Exact<{
  stepId: Scalars['ID']['input'];
  moduleId: Scalars['ID']['input'];
  graphNodeStepId: Scalars['ID']['input'];
  byModule: Scalars['Boolean']['input'];
  placement: Scalars['Boolean']['input'];
}>;


export type StepArticleColorsQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', step?: { __typename?: 'Step', id: string, articleAllocations: Array<{ __typename: 'EbomPartAllocation', article: { __typename?: 'Article', articleNumber: string, type: ArticleType } } | { __typename: 'ManualArticleAllocation', article: { __typename?: 'Article', articleNumber: string, type: ArticleType } }>, inputs: Array<{ __typename?: 'StepInput', output: { __typename?: 'StepOutput', article: { __typename?: 'Article', articleNumber: string } } }>, module?: { __typename?: 'Module', id: string, nodes: Array<{ __typename?: 'StepNode', id: string, parentId?: string, effectiveArticleAllocations: Array<{ __typename: 'EbomPartAllocation', article: { __typename?: 'Article', articleNumber: string, type: ArticleType } } | { __typename: 'ManualArticleAllocation', article: { __typename?: 'Article', articleNumber: string, type: ArticleType } }>, effectiveInputs: Array<{ __typename?: 'StepInput', output: { __typename?: 'StepOutput', article: { __typename?: 'Article', articleNumber: string } } }> }> } }, module?: { __typename?: 'Module', id: string, nodes: Array<{ __typename?: 'StepNode', id: string, parentId?: string, effectiveArticleAllocations: Array<{ __typename: 'EbomPartAllocation', article: { __typename?: 'Article', articleNumber: string, type: ArticleType } } | { __typename: 'ManualArticleAllocation', article: { __typename?: 'Article', articleNumber: string, type: ArticleType } }>, effectiveInputs: Array<{ __typename?: 'StepInput', output: { __typename?: 'StepOutput', article: { __typename?: 'Article', articleNumber: string } } }> }> }, placementArticleAllocations?: Array<{ __typename: 'EbomPartAllocation', article: { __typename?: 'Article', articleNumber: string, type: ArticleType } } | { __typename: 'ManualArticleAllocation', article: { __typename?: 'Article', articleNumber: string, type: ArticleType } }>, placementStepInputs?: Array<{ __typename?: 'StepInput', output: { __typename?: 'StepOutput', article: { __typename?: 'Article', articleNumber: string } } }> } };

export type StepArticleColorsModuleFragment = { __typename?: 'Module', id: string, nodes: Array<{ __typename?: 'StepNode', id: string, parentId?: string, effectiveArticleAllocations: Array<{ __typename: 'EbomPartAllocation', article: { __typename?: 'Article', articleNumber: string, type: ArticleType } } | { __typename: 'ManualArticleAllocation', article: { __typename?: 'Article', articleNumber: string, type: ArticleType } }>, effectiveInputs: Array<{ __typename?: 'StepInput', output: { __typename?: 'StepOutput', article: { __typename?: 'Article', articleNumber: string } } }> }> };

type StepArticleColorsAllocation_EbomPartAllocation_Fragment = { __typename: 'EbomPartAllocation', article: { __typename?: 'Article', articleNumber: string, type: ArticleType } };

type StepArticleColorsAllocation_ManualArticleAllocation_Fragment = { __typename: 'ManualArticleAllocation', article: { __typename?: 'Article', articleNumber: string, type: ArticleType } };

export type StepArticleColorsAllocationFragment = StepArticleColorsAllocation_EbomPartAllocation_Fragment | StepArticleColorsAllocation_ManualArticleAllocation_Fragment;

export type StepArticleColorsInputFragment = { __typename?: 'StepInput', output: { __typename?: 'StepOutput', article: { __typename?: 'Article', articleNumber: string } } };

export type FinalizeMultipartUploadMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FinalizeMultipartUploadMutation = { __typename?: 'Mutation', upload: { __typename?: 'UploadMutationRoot', finalizeMultipartUpload: { __typename?: 'Upload', id: string, name: string, contentType: string, createdAt: any } } };

export type CreateMultipartUploadMutationVariables = Exact<{
  command: CreateMultipartUpload;
}>;


export type CreateMultipartUploadMutation = { __typename?: 'Mutation', upload: { __typename?: 'UploadMutationRoot', createMultipartUpload: string } };

export type BreadcrumbCachedProductNameFragment = { __typename?: 'Product', name: string };

export type BreadcrumbCachedConfigNameFragment = { __typename?: 'ProductConfiguration', name: string };

export type BreadcrumbCachedSiteNameFragment = { __typename?: 'Site', name: string };

export type BreadcrumbCachedModuleNameFragment = { __typename?: 'Module', name: string };

export type BreadcrumbCachedEbomNameFragment = { __typename?: 'Ebom', name: string };

export type BreadcrumbCachedBopVersionFragment = { __typename?: 'BOP', version: number, versionStatus: VersionStatus };

export type HomeViewDataQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeViewDataQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', organizations: Array<{ __typename?: 'OrganizationUserPermissions', organization: { __typename?: 'Organization', id: string, name: string, slug: string } }> } };

export type AdminOrganizationViewDataQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminOrganizationViewDataQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', adminOrganizations: Array<{ __typename?: 'Organization', id: string, name: string, slug: string }> } };

export type AdminOrganizationViewCreateMutationVariables = Exact<{
  command: CreateOrganization;
}>;


export type AdminOrganizationViewCreateMutation = { __typename?: 'Mutation', account: { __typename?: 'AccountMutationRoot', adminCreateOrganization: { __typename?: 'Organization', id: string } } };

export type AdminOrganizationViewUpdateMutationVariables = Exact<{
  command: UpdateOrganization;
}>;


export type AdminOrganizationViewUpdateMutation = { __typename?: 'Mutation', account: { __typename?: 'AccountMutationRoot', adminUpdateOrganization: { __typename?: 'Organization', id: string } } };

export type AdminOrganizationViewDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminOrganizationViewDeleteMutation = { __typename?: 'Mutation', account: { __typename?: 'AccountMutationRoot', adminDeleteOrganization: string } };

export type AdminUserViewDataQueryVariables = Exact<{
  contains?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminUserViewDataQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', adminSearchUsers: Array<{ __typename?: 'User', id: string, email: string, firstname: string, lastname: string }> } };

export type AdminUserViewCreateMutationVariables = Exact<{
  command: CreateUser;
}>;


export type AdminUserViewCreateMutation = { __typename?: 'Mutation', account: { __typename?: 'AccountMutationRoot', adminCreateUser: { __typename?: 'User', id: string } } };

export type AdminUserViewUpdateMutationVariables = Exact<{
  command: UpdateUser;
}>;


export type AdminUserViewUpdateMutation = { __typename?: 'Mutation', account: { __typename?: 'AccountMutationRoot', adminUpdateUser: { __typename?: 'User', id: string } } };

export type ArticleViewDataQueryVariables = Exact<{
  query: ArticleSearchQuery;
}>;


export type ArticleViewDataQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', articles: Array<{ __typename?: 'Article', id: string, type: ArticleType, articleNumber: string, revision: string, unit: ArticleUnit, name?: string, released: boolean }> } };

export type ArticleViewUpdateArticleMutationVariables = Exact<{
  command: UpdateArticle;
}>;


export type ArticleViewUpdateArticleMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', updateArticle: { __typename?: 'Article', id: string } } };

export type ArticleViewDeleteArticleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArticleViewDeleteArticleMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', deleteArticle: string } };

export type BopProcessViewDataQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
  productConfigId: Scalars['ID']['input'];
  bopId: Scalars['ID']['input'];
}>;


export type BopProcessViewDataQuery = { __typename?: 'Query', site: { __typename?: 'SiteRoot', site: { __typename?: 'Site', id: string, abbreviation: string } }, product: { __typename?: 'ProductRoot', product: { __typename?: 'Product', id: string, abbreviation: string }, productConfiguration: { __typename?: 'ProductConfiguration', id: string, abbreviation: string }, bop: { __typename?: 'BOP', id: string, versionStatus: VersionStatus, productConfiguration: { __typename?: 'ProductConfiguration', id: string, archived: boolean }, nodes: Array<{ __typename?: 'ModuleNode', id: string, parentIds: Array<string>, module: { __typename?: 'Module', id: string, name: string, abbreviation: string, description?: string, inputs: Array<{ __typename?: 'StepInput', id: string, milliQuantity: number, module: { __typename?: 'Module', id: string }, output: { __typename?: 'StepOutput', id: string, module?: { __typename?: 'Module', id: string }, article: { __typename?: 'Article', id: string, articleNumber: string, revision: string, unit: ArticleUnit } } }> } }> } } };

export type SetGraphMutationVariables = Exact<{
  graph: SetDagGraph;
}>;


export type SetGraphMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', setBillOfProcessGraph: boolean } };

export type CreateModuleMutationVariables = Exact<{
  module: CreateModule;
  graph: SetDagGraph;
}>;


export type CreateModuleMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', setBillOfProcessGraph: boolean, createModule: { __typename?: 'Module', id: string } } };

export type BopProcessViewUpdateMutationVariables = Exact<{
  module: UpdateModule;
}>;


export type BopProcessViewUpdateMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', updateModule: { __typename?: 'Module', id: string } } };

export type DeleteModuleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteModuleMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', deleteModule?: string } };

export type BopViewDataQueryVariables = Exact<{
  configId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
}>;


export type BopViewDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', productConfiguration: { __typename?: 'ProductConfiguration', id: string, archived: boolean, bopsAtSite: Array<{ __typename?: 'BOP', id: string, version: number, versionStatus: VersionStatus }> } } };

export type BopViewCreateMutationVariables = Exact<{
  configId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
}>;


export type BopViewCreateMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', draftBOP: { __typename?: 'BOP', id: string } } };

export type BopViewDuplicateMutationVariables = Exact<{
  command: DraftBopByDuplicating;
}>;


export type BopViewDuplicateMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', draftBOPByDuplicating: { __typename?: 'BOP', id: string } } };

export type BopViewDeleteMutationVariables = Exact<{
  configId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
}>;


export type BopViewDeleteMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', deleteLatestUnreleasedBOPVersion?: string } };

export type GetEbomQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetEbomQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', ebom: { __typename?: 'Ebom', id: string, name: string, sourceId: string, sourceType: EbomSourceType, ebomParts: Array<{ __typename?: 'EbomPart', id: string, articleNumber: string, articlePath: { __typename?: 'ArticlePath', articleNumbers: Array<string> } }> } } };

export type IconViewDataQueryVariables = Exact<{ [key: string]: never; }>;


export type IconViewDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', icons: Array<{ __typename?: 'Icon', id: string, name: string, imageUpload?: { __typename?: 'Upload', id: string, imageUrl: string } }> } };

export type IconViewCreateMutationVariables = Exact<{
  command: CreateIcon;
}>;


export type IconViewCreateMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createIcon: { __typename?: 'Icon', id: string } } };

export type IconViewUpdateMutationVariables = Exact<{
  command: UpdateIcon;
}>;


export type IconViewUpdateMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', updateIcon: { __typename?: 'Icon', id: string, name: string } } };

export type IconViewDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IconViewDeleteMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', deleteIcon: string } };

export type IssueLabelViewDataQueryVariables = Exact<{ [key: string]: never; }>;


export type IssueLabelViewDataQuery = { __typename?: 'Query', issue: { __typename?: 'IssueRoot', orgIssueLabels: Array<{ __typename?: 'IssueLabel', id: string, name: string, color: string }> } };

export type IssueLabelViewCreateMutationVariables = Exact<{
  command: CreateIssueLabel;
}>;


export type IssueLabelViewCreateMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', createIssueLabel: { __typename?: 'IssueLabel', id: string } } };

export type IssueLabelViewUpdateMutationVariables = Exact<{
  command: UpdateIssueLabel;
}>;


export type IssueLabelViewUpdateMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', updateIssueLabel: { __typename?: 'IssueLabel', id: string } } };

export type IssueLabelViewDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IssueLabelViewDeleteMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', deleteIssueLabel: string } };

export type IssueViewDataQueryVariables = Exact<{
  query: IssueSearchQuery;
}>;


export type IssueViewDataQuery = { __typename?: 'Query', issue: { __typename?: 'IssueRoot', issues: Array<{ __typename?: 'Issue', id: string, name: string, createdAt: any, updatedAt: any, resolvedAt?: any, assignedToUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }>, labels: Array<{ __typename?: 'IssueLabel', id: string, name: string, color: string }>, links: Array<{ __typename?: 'ArticleIssueLink', id: string, article: { __typename?: 'Article', id: string, articleNumber: string, revision: string } } | { __typename?: 'BOPIssueLink', id: string, bop: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } } } | { __typename?: 'ModuleIssueLink', id: string, bop: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } }, module: { __typename?: 'Module', id: string, name: string } } | { __typename?: 'SerialNumberIssueLink', id: string, poNumber: string, serialNumber: string, bop: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } }, module: { __typename?: 'Module', id: string, name: string }, step: { __typename?: 'Step', id: string, name: string } } | { __typename?: 'StepIssueLink', id: string, bop: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } }, module: { __typename?: 'Module', id: string, name: string }, step: { __typename?: 'Step', id: string, name: string } }> }> } };

export type LibraryStepViewDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LibraryStepViewDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', step: { __typename?: 'Step', id: string, name: string, instructionText?: string, warningText?: string, durationInSeconds: number, toolIds: Array<string>, stepType: { __typename?: 'StepType', id: string } } } };

export type LibraryStepViewUpdateMutationVariables = Exact<{
  command: UpdateStep;
}>;


export type LibraryStepViewUpdateMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', updateStep: { __typename?: 'Step', id: string } } };

export type LibraryViewDataQueryVariables = Exact<{ [key: string]: never; }>;


export type LibraryViewDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', librarySteps: Array<{ __typename?: 'Step', id: string, name: string, instructionText?: string, updatedAt: any, usageCount: number }> } };

export type LibraryViewCreateStepMutationVariables = Exact<{
  command: CreateStep;
}>;


export type LibraryViewCreateStepMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createStep: { __typename?: 'Step', id: string } } };

export type ModuleViewDataQueryVariables = Exact<{
  bopId: Scalars['ID']['input'];
  moduleId: Scalars['ID']['input'];
}>;


export type ModuleViewDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', bop: { __typename?: 'BOP', id: string, versionStatus: VersionStatus, productConfiguration: { __typename?: 'ProductConfiguration', id: string, archived: boolean }, uploads: Array<{ __typename?: 'BOPUpload', glbStatus: GlbStatus }> }, module: { __typename?: 'Module', id: string, name: string, abbreviation: string, nodes: Array<{ __typename?: 'StepNode', id: string, parentId?: string, isLibraryReference: boolean, step: { __typename?: 'Step', id: string } }> } } };

export type ModuleViewSelectedStepQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ModuleViewSelectedStepQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', step: { __typename?: 'Step', id: string, library: boolean } } };

export type OrgHomeDataQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgHomeDataQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', me?: { __typename?: 'CurrentUserAndPermissions', organization?: { __typename?: 'Organization', id: string, name: string } } } };

export type ProductConfigurationViewDataQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type ProductConfigurationViewDataQuery = { __typename?: 'Query', site: { __typename?: 'SiteRoot', sites: Array<{ __typename?: 'Site', id: string, name: string }> }, product: { __typename?: 'ProductRoot', product: { __typename?: 'Product', id: string, name: string, archived: boolean, productConfigurations: Array<{ __typename?: 'ProductConfiguration', id: string, name: string, abbreviation: string, description?: string, imageUploadId?: string, archived: boolean, imageUpload?: { __typename?: 'Upload', id: string, imageUrl: string }, bops: Array<{ __typename?: 'BOP', id: string, version: number, versionStatus: VersionStatus, site: { __typename?: 'Site', id: string, name: string } }> }> } } };

export type ProductConfigurationViewCreateMutationVariables = Exact<{
  command: CreateProductConfiguration;
}>;


export type ProductConfigurationViewCreateMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createProductConfiguration: { __typename?: 'ProductConfiguration', id: string } } };

export type ProductConfigurationViewUpdateMutationVariables = Exact<{
  command: UpdateProductConfiguration;
}>;


export type ProductConfigurationViewUpdateMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', updateProductConfiguration: { __typename?: 'ProductConfiguration', id: string } } };

export type ProductConfigurationViewDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProductConfigurationViewDeleteMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', deleteProductConfiguration: string } };

export type ProductConfigurationViewArchiveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProductConfigurationViewArchiveMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', archiveProductConfiguration: { __typename?: 'ProductConfiguration', id: string } } };

export type ProductConfigurationViewUnarchiveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProductConfigurationViewUnarchiveMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', unarchiveProductConfiguration: { __typename?: 'ProductConfiguration', id: string } } };

export type ProductConfigurationViewUnarchiveProductMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProductConfigurationViewUnarchiveProductMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', unarchiveProduct: { __typename?: 'Product', id: string } } };

export type ProductViewDataQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductViewDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', products: Array<{ __typename?: 'Product', id: string, name: string, abbreviation: string, description?: string, imageUploadId?: string, archived: boolean, imageUpload?: { __typename?: 'Upload', id: string, imageUrl: string } }> } };

export type ProductViewCreateMutationVariables = Exact<{
  command: CreateProduct;
}>;


export type ProductViewCreateMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createProduct: { __typename?: 'Product', id: string } } };

export type ProductViewUpdateMutationVariables = Exact<{
  command: UpdateProduct;
}>;


export type ProductViewUpdateMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', updateProduct: { __typename?: 'Product', id: string } } };

export type ProductViewDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProductViewDeleteMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', deleteProduct: string } };

export type ProductViewArchiveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProductViewArchiveMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', archiveProduct: { __typename?: 'Product', id: string } } };

export type ProductViewUnarchiveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProductViewUnarchiveMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', unarchiveProduct: { __typename?: 'Product', id: string } } };

export type ProductionBatchViewDataQueryVariables = Exact<{
  query: ProductionBatchQuery;
}>;


export type ProductionBatchViewDataQuery = { __typename?: 'Query', shopFloor: { __typename?: 'ShopFloorRoot', productionBatches: { __typename?: 'ProductionBatchPage', page: number, itemsPerPage: number, totalItems: number, totalPages: number, data: Array<{ __typename?: 'ProductionBatch', id: string, poNumber: string, serialNumbers: Array<string>, completed: boolean, startedAt?: any, completedAt?: any, durationInSeconds?: number, module: { __typename?: 'Module', id: string, name: string }, bop: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } } }> } } };

export type SitesViewDataQueryVariables = Exact<{ [key: string]: never; }>;


export type SitesViewDataQuery = { __typename?: 'Query', site: { __typename?: 'SiteRoot', sites: Array<{ __typename?: 'Site', id: string, name: string, abbreviation: string, archived: boolean }> } };

export type SiteViewCreateMutationVariables = Exact<{
  command: CreateSite;
}>;


export type SiteViewCreateMutation = { __typename?: 'Mutation', site: { __typename?: 'SiteMutationRoot', createSite: { __typename?: 'Site', id: string } } };

export type SiteViewUpdateMutationVariables = Exact<{
  command: UpdateSite;
}>;


export type SiteViewUpdateMutation = { __typename?: 'Mutation', site: { __typename?: 'SiteMutationRoot', updateSite: { __typename?: 'Site', id: string } } };

export type SiteViewDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SiteViewDeleteMutation = { __typename?: 'Mutation', site: { __typename?: 'SiteMutationRoot', deleteSite: string } };

export type StepTypeViewDataQueryVariables = Exact<{ [key: string]: never; }>;


export type StepTypeViewDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', stepTypes: Array<{ __typename?: 'StepType', id: string, name: string, archived: boolean, released: boolean }> } };

export type StepTypeViewCreateMutationVariables = Exact<{
  command: CreateStepType;
}>;


export type StepTypeViewCreateMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createStepType: { __typename?: 'StepType', id: string } } };

export type StepTypeViewUpdateMutationVariables = Exact<{
  command: UpdateStepType;
}>;


export type StepTypeViewUpdateMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', updateStepType: { __typename?: 'StepType', id: string } } };

export type StepTypeViewDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StepTypeViewDeleteMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', deleteStepType: string } };

export type ToolsViewDataQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type ToolsViewDataQuery = { __typename?: 'Query', site: { __typename?: 'SiteRoot', site: { __typename?: 'Site', tools: Array<{ __typename?: 'Tool', id: string, name: string, description?: string, archived: boolean, released: boolean, imageUploads: Array<{ __typename?: 'Upload', id: string }> }> } } };

export type ToolsViewCreateMutationVariables = Exact<{
  command: CreateTool;
}>;


export type ToolsViewCreateMutation = { __typename?: 'Mutation', site: { __typename?: 'SiteMutationRoot', createTool: { __typename?: 'Tool', id: string } } };

export type ToolsViewUpdateMutationVariables = Exact<{
  command: UpdateTool;
}>;


export type ToolsViewUpdateMutation = { __typename?: 'Mutation', site: { __typename?: 'SiteMutationRoot', updateTool: { __typename?: 'Tool', id: string } } };

export type ToolsViewDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ToolsViewDeleteMutation = { __typename?: 'Mutation', site: { __typename?: 'SiteMutationRoot', deleteTool: string } };

export type UploadViewDataQueryVariables = Exact<{
  query: UploadQuery;
  imageOptions: ImageOptions;
}>;


export type UploadViewDataQuery = { __typename?: 'Query', upload: { __typename?: 'UploadRoot', search: Array<{ __typename?: 'Upload', id: string, name: string, contentType: string, createdAt: any, extension: { __typename?: 'CsvExtension' } | { __typename?: 'GenericExtension' } | { __typename?: 'ImageExtension', url: string } | { __typename?: 'ModelExtension' } | { __typename?: 'PdfExtension' } | { __typename?: 'VideoExtension' }, usageLocations: Array<{ __typename: 'BOPUploadUsageLocation', bop?: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } } } | { __typename: 'CheckUploadUsageLocation', step: { __typename?: 'Step', id: string, name: string }, module?: { __typename?: 'Module', id: string, name: string }, bop?: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } } } | { __typename: 'IconUploadUsageLocation', icon?: { __typename?: 'Icon', id: string, name: string } } | { __typename: 'IssueCommentUploadUsageLocation', comment: { __typename?: 'IssueComment', id: string }, issue: { __typename?: 'Issue', id: string, name: string } } | { __typename: 'IssueUploadUsageLocation', issue: { __typename?: 'Issue', id: string, name: string } } | { __typename: 'ProductConfigurationUploadUsageLocation', productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } } } | { __typename: 'ProductUploadUsageLocation', product: { __typename?: 'Product', id: string, name: string } } | { __typename: 'StepImageUploadUsageLocation', step: { __typename?: 'Step', id: string, name: string }, module?: { __typename?: 'Module', id: string, name: string }, bop?: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } } } | { __typename: 'StepUploadUsageLocation', step: { __typename?: 'Step', id: string, name: string }, module?: { __typename?: 'Module', id: string, name: string }, bop?: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } } } | { __typename: 'ToolImageUploadUsageLocation', tool: { __typename?: 'Tool', id: string, name: string }, site?: { __typename?: 'Site', id: string, name: string } }> }> } };

export type UploadViewDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UploadViewDeleteMutation = { __typename?: 'Mutation', upload: { __typename?: 'UploadMutationRoot', deleteUpload: string } };

export type UploadViewUpdateMutationVariables = Exact<{
  command: UpdateUpload;
}>;


export type UploadViewUpdateMutation = { __typename?: 'Mutation', upload: { __typename?: 'UploadMutationRoot', updateUpload: { __typename?: 'Upload', id: string, name: string } } };

export type OrgUserViewDataQueryVariables = Exact<{
  contains?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrgUserViewDataQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', organizationSearchUsers: Array<{ __typename?: 'User', id: string, email: string, firstname: string, lastname: string }> } };

export type OrgUserViewCreateMutationVariables = Exact<{
  userCommand: CreateUser;
  permissions: Array<PermissionOrganization> | PermissionOrganization;
}>;


export type OrgUserViewCreateMutation = { __typename?: 'Mutation', account: { __typename?: 'AccountMutationRoot', inviteUserToOrganization: boolean } };

export type UserOrganizationPermissionsDeleteMutationVariables = Exact<{
  command: DeleteOrganizationPermissions;
}>;


export type UserOrganizationPermissionsDeleteMutation = { __typename?: 'Mutation', account: { __typename?: 'AccountMutationRoot', deleteOrganizationPermissions: boolean } };

export type OperatorViewDataQueryVariables = Exact<{ [key: string]: never; }>;


export type OperatorViewDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', products: Array<{ __typename?: 'Product', id: string, name: string, abbreviation: string, description?: string, imageUploadId?: string, archived: boolean, imageUpload?: { __typename?: 'Upload', id: string, imageUrl: string } }> } };

export type OperatorStepTreeDataQueryVariables = Exact<{
  bopId: Scalars['ID']['input'];
  moduleId: Scalars['ID']['input'];
}>;


export type OperatorStepTreeDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', bop: { __typename?: 'BOP', id: string, uploads: Array<{ __typename?: 'BOPUpload', glbStatus: GlbStatus }> }, module: { __typename?: 'Module', id: string, abbreviation: string, nodes: Array<{ __typename?: 'StepNode', id: string, parentId?: string, changeKind?: StepChangeKind, movedFrom?: Array<number>, isLibraryReference: boolean, step: { __typename?: 'Step', id: string, name: string, icons: Array<{ __typename?: 'Icon', id: string, name: string, imageUpload?: { __typename?: 'Upload', id: string, imageUrl: string } }>, stepType: { __typename?: 'StepType', id: string, name: string } } }>, removedSteps: Array<{ __typename?: 'RemovedStep', parentStepId?: string, afterStepId?: string, step: { __typename?: 'Step', id: string, name: string, icons: Array<{ __typename?: 'Icon', id: string, name: string, imageUpload?: { __typename?: 'Upload', id: string, imageUrl: string } }>, stepType: { __typename?: 'StepType', id: string, name: string } } }> } } };

export type OperatorProductConfigurationViewDataQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type OperatorProductConfigurationViewDataQuery = { __typename?: 'Query', site: { __typename?: 'SiteRoot', sites: Array<{ __typename?: 'Site', id: string, name: string }> }, product: { __typename?: 'ProductRoot', product: { __typename?: 'Product', productConfigurations: Array<{ __typename?: 'ProductConfiguration', id: string, name: string, abbreviation: string, description?: string, imageUploadId?: string, archived: boolean, imageUpload?: { __typename?: 'Upload', id: string, imageUrl: string }, bops: Array<{ __typename?: 'BOP', id: string, version: number, versionStatus: VersionStatus, site: { __typename?: 'Site', id: string, name: string }, nodes: Array<{ __typename?: 'ModuleNode', module: { __typename?: 'Module', id: string, name: string, description?: string, abbreviation: string } }> }> }> } } };
